var ADV = (function(app) {
  app.settings = $.extend(
    {
      colors: ['#5abee4', '#89ce41', '#ff9e13', '#63146b', '#e75953'],
      color_groups: [
        ['#5abee4', '#76c9e9', '#92d4ed', '#aedff2', '#4b9ebd', '#3b7d96', '#2c5d70', '#1d3d49'],
        ['#89ce41', '#9dd661', '#b1df82', '#c5e7a2', '#72ab36', '#5a882b', '#436520', '#2c4215'],
        ['#ff9e13', '#ffae3b', '#ffbf63', '#ffcf8b', '#d48310', '#a8680d', '#7d4d09', '#523306'],
        ['#63146b', '#7e3c84', '#98649d', '#b38cb6', '#521159', '#410d47', '#310a34', '#200622'],
        ['#e75953', '#eb7570', '#ef918d', '#f3aeab', '#c04a45', '#983b37', '#712c29', '#4a1c1b'],
        ['#cabffd', '#A07DB1', '#BFA8CC', '#DFD3E5', '#572A79', '#501E6A', '#411957', '#331444'],
      ],
      debt_management_colors: ['#4b9ebd', '#410d47'],
      expresswizard_colors: ['#4591ad', '#5fbfe2', '#b7ecff', '#7F5197', '#A07DB1'],
      breakdown_colors: [
        '#5abee4',
        '#2eaddd',
        '#3b7d96',
        '#2c5d70',
        '#7e3c84',
        '#63146b',
        '#521159',
        '#410d47',
      ],
      retirement_income_colors: ['#0078D4', '#6B3FA0', '#BF5700', '#B8DFF0', '#6092B4', '#686E7E'],

      MsgLib: {
        generic_error: 'Sorry, an error has occurred. Please try again.',
        cannot_connect:
          '<i class="fa fa-flash" style="font-size:39px;color:#ddd;display:block;float:left;margin:3px 13px 0 0;"></i>Sorry, we\'re having trouble connecting to our server. Please check your connection and try again.',
        timeout_warning:
          'Your session is about to be timed out for security reasons. Would you like stay logged in?',
        generic_account_linking_error:
          'Sorry, we were unable to import this account at this time. Please try again later, or contact us if you continue to experience this problem.',
        buttons: {
          default_button_ok: 'OK',
          default_button_cancel: 'Cancel',
        },
        FinancialPlan: {
          notice_changed_settings:
            'Your settings have been changed since this plan was generated. Would you like to reset this plan?',
          notice_changed_settings_warning:
            'Are you sure you want to reset all <strong class="weight-600">' +
            'what ifs</strong> variables? This will set all ' +
            'variables in the <strong class="weight-600">what ifs</strong> section ' +
            'for all goals to match their values in the ' +
            '<strong class="weight-600">profile</strong> section. All changes ' +
            'to the <strong class="weight-600">what ifs</strong> section for all ' +
            'goals will be lost.',
          notice_changed_profile:
            'An input on this client\'s <strong class="weight-600">' +
            'profile</strong> section has changed since the <strong class="weight-600">' +
            'recommendations</strong> page was last run. Would you like ' +
            'to reset all <strong class="weight-600">what ifs</strong> variables for all ' +
            'goals in this plan to match the <strong class="weight-600">profile</strong> section?',
          notice_changed_profile_consumer:
            'The <strong class="weight-600">profile</strong> has changed since the <strong class="weight-600">' +
            'recommendations</strong> page was last updated. Would you like to reset all <strong class="weight-600">' +
            'what ifs</strong> values for all goals to match the <strong class="weight-600">profile</strong> section?',
        },
      },

      misc: {
        notification_update_frequency: 1000 * 60,
        notification_limit: 10,
        session_timeout: 60 * 60 * 1000, //in milliseconds
        session_warning_time: 2 * 60 * 1000, //amount of warning to give, in milliseconds, before session timeout occurs
      },

      AccountLinking: {
        poll_interval: 1000, //in milliseconds
        fail_timeout_interval: 5 * 60 * 1000, //how long to wait until giving up, in milliseconds.
      },
    },
    app.settings || {},
  );
  return app;
})(ADV || {});

(function() {
  const js_dir = `${ADV.settings.endpoints.assets}js/`;

  ADV.resources = $.extend(
    {
      profile_accounts: [`${js_dir}profile_accounts.js`],

      calibrate: [`${js_dir}calibrate.js`],

      document_vault: [`${js_dir}document_vault.js`],

      settings: [`${js_dir}settings.js`],
    },
    ADV.resources || {},
  );
})();

/* eslint-disable @typescript-eslint/camelcase */
/* eslint camelcase: 0 */

const R = 'React';

ADV.routes = {
  PageNotFound: { path: 'pageNotFound', type: R },
  FatalError: { path: 'fatalError', type: R },

  // Client Overview (react)
  ConsumerOverview: { path: 'overview/:clientId', type: R },

  UserActivity: { path: 'activity/:clientId', type: R },

  // Adviser Area
  GetStarted: { path: 'start', type: R },
  ClientEditPlan: { path: 'editplan/:clientId', type: R },
  ClientStartPage: { path: 'start/:clientId', type: R },
  Dashboard: { path: 'dashboard', type: R },
  Checkout: { path: 'Checkout', type: R },

  // reports
  NetWorth: { path: 'networth/:clientId/:pivot', type: R },
  Transactions: { path: 'transactions/:clientId/:accountId', type: R },
  ProjectedCashFlowReport: {
    path: 'projectedcashflowreport/:clientId/:mode',
    type: R,
    has_plan_selection: true,
  },
  ReactAssetAllocationReport: {
    path: 'reports/AssetAllocation/:clientId',
    type: R,
    has_plan_selection: true,
  },
  PortfolioReports: {
    path: 'portfolio-reports/:clientId',
    type: R,
    has_plan_selection: false,
  },
  AdvancedReports: { path: 'reports/:clientId/:mode', type: R, has_plan_selection: true },
  Assumptions: { path: 'assumptions/:clientId', type: R },

  // financial plan
  NewFinancialPlanWhatIfs: {
    path: 'planWhatIfs/:clientId/:goalId/:workflowEnded/:origin/:tab',
    type: R,
    has_plan_selection: true,
  },

  ProjectedBalanceSheet: {
    path: 'balance_sheet/:clientId/:is_projected',
    type: R,
    has_plan_selection: true,
  },

  // ============
  // Goals
  // ============
  Goal: {
    path: 'goal/:clientId/:goalId/:workflowEnded/:tab',
    type: R,
    has_plan_selection: true,
  },

  GoalsSummary: {
    path: 'goalsSummary/:clientId',
    type: R,
    has_plan_selection: true,
  },

  // tasks (react)
  TasksV2: { path: 'tasksV2/:clientId', type: R, has_plan_selection: true },

  /**
   * This component ensures backwards compatibility with the previous route scheme for the
   * Document Vault. Reason: some users might have old links or notification emails bookmarked.
   */
  DocumentVaultRedirect: { path: 'document_vault/:clientId/:navigateTo', type: R },

  // Document Vault
  DocumentVault: {
    path: 'document-vault/:clientId/:path/:providerType/:filterableByYear/:previousComponent',
    type: R,
  },

  // managed accounts
  AccountOpening: { path: 'account-opening/:clientId/:isFromWorkflow/:draftId', type: R },

  // pdf
  AdvancedPDF: { path: 'pdf/:clientId', type: R, has_plan_selection: true },

  // workflow. if any parameter is not used/unknown, provide 0 instead.
  // #workflow/0/1/personalinfo/930/0 <-- this will go to Personal Info in workflow 0.
  // stepId (1) is from the backend. client is 930
  // #workflow/2/0/start/930/0 <-- this will start workflow 2 for client 930
  Workflow: {
    path: 'workflow/:workflowId/:stepId/:pageId/:clientId/:pivotId/:institutionId',
    type: R,
  },

  // consumer area workflow start/end pages (acts like bookends for the workflow in consumer area).
  ConsumerWorkflowStart: { path: 'workflow/start/:clientId', type: R },
  ConsumerYouAreDone: { path: 'workflow/done/:clientId', type: R },
  DebtManagementWorkflow: {
    path: 'workflow_debt_management/:clientId/:goToSummaryWhenReady',
    type: R,
  },
  DebtManagementWorkflowDone: { path: 'workflow_done_debt_management/:clientId', type: R },
  AllWorkflowsDone: { path: 'all_workflows_done/:clientId', type: R },
  FinancialAccountsWorkflow: {
    path: 'workflow_financial_accounts/:clientId/:goToSummaryWhenReady',
    type: R,
  },
  WorkflowDoneV2: { path: 'workflow_done/:clientId', type: R },
  WorkflowDoneV3: { path: 'workflow_done/:clientId/:workflowId', type: R },
  FinancialAccountsWorkflowDone: { path: 'workflow_financial_accounts_done/:clientId', type: R },
  RetirementWorkflow: { path: 'workflow_retirement/:clientId/:goToSummaryWhenReady', type: R },
  RetirementWorkflowDone: { path: 'workflow_done_retirement/:clientId', type: R },
  EducationWorkflowDone: { path: 'workflow_done_education/:clientId', type: R },
  EducationWorkflow: {
    path: 'workflow_education/:clientId/:goToSummaryWhenReady/:selectedGoalId',
    type: R,
  },
  HomePurchaseWorkflow: { path: 'workflow_homePurchase/:clientId/:goToSummaryWhenReady', type: R },
  HomePurchaseWorkflowDone: { path: 'workflow_homePurchase_done/:clientId', type: R },
  EmergencyFundWorkflow: {
    path: 'workflow_emergencyFund/:clientId/:goToSummaryWhenReady',
    type: R,
  },
  EmergencyFundWorkflowDone: { path: 'workflow_emergencyFund_done/:clientId', type: R },
  DecumulationWorkflow: {
    path: 'workflow_decumulation/:clientId/:goToSummaryWhenReady',
    type: R,
  },
  DecumulationWorkflowDone: { path: 'workflow_decumulation_done/:clientId', type: R },
  LargePurchaseWorkflow: {
    path: 'workflow_largePurchase/:clientId/:goToSummaryWhenReady/:selectedGoalId',
    type: R,
  },
  LargePurchaseWorkflowDone: { path: 'workflow_largePurchase_done/:clientId', type: R },

  HealthCareWorkflow: { path: 'workflow_healthcare/:clientId/:goToSummaryWhenReady', type: R },
  HealthCareWorkflowDone: { path: 'workflow_done_healthcare/:clientId', type: R },
  RiskToleranceWorkflow: {
    path: 'workflow_risk_tolerance/:clientId/:redirectTo',
    type: R,
  },

  // profile. if any variable is not used, provide 0 instead. ex:
  // #profile/personalinfo/930/0
  // NOTE: HM-specific pages need to go above the "Profile" catch-all in order to be found.
  ProfileAccounts: {
    path: 'profile/accounts/:clientId/:tabSlug/:entityId',
    type: R,
  },
  ProfileStockOptions: { path: 'profile/stockoptions/:clientId/:pivotId', type: R },
  ProfileInsurance: { path: 'profile/insurance/:clientId/:pivotId', type: R },
  ProfileExpenses: { path: 'profile/expenses/:clientId/:pivotId', type: R },
  ProfileIncome: { path: 'profile/income/:clientId', type: R },

  // OLD React routes.
  // Do not delete until we migrate everything from accounts
  // some components are still used on the new work.
  // - Accounts Page      done on: ADV-8633
  // - Manage Links Page  done on: ADV-8633
  // - Add, Edit Modals
  ProfileAccountsOld: { path: 'profile/accounts_old/:clientId/:pivotId', type: R },
  ProfileLinkAccounts: {
    path: 'profile/linkAccounts/:clientId/:institutionLinkId/:fixConnection',
    type: R,
  },
  // OLD React routes.

  ProfileRiskTolerance: { path: 'profile/risktolerance/:clientId/:pivotId', type: R },
  Profile: { path: 'profile/:pageId/:clientId/:pivotId', type: R },

  ClientSearch: { path: 'search_client', type: R },

  PdfImport: { path: 'pdf-import', type: R },

  ClientSettings: { path: 'client_settings/:clientId', type: R },

  Alight: { path: 'alight', type: R },

  NoClientAccess: { path: 'noaccess', type: R },

  AdviserSettings: {
    path: 'Application/Settings/:page',
    type: R,
  },

  Leads: {
    path: 'Leads',
    type: R,
  },

  AccountPerformanceReporting: {
    path:
      'AccountAccountPerformanceReporting/:clientId/:groupId/:accountId/:tabSlug/:allocationType/:isApex/:isLandingPageOption',
    type: R,
    skipWrapper: true,
  },

  Campaigns: {
    path: 'campaigns',
    type: R,
  },

  ApexAccount: { path: 'apex_account/:clientId/:accountId', type: R },

  MoneyGuidePro: { path: 'money_guide_pro/:clientId/:tabSlug/:tabId', type: R },

  EMoney: { path: 'eMoney/:clientId', type: R },

  Schwab: { path: 'schwab/:clientId', type: R },

  RISA: { path: 'RISA/:clientId', type: R },

  OrionTrading: { path: 'orion_trading/:clientId/:tabSlug', type: R },

  DataReconciliation: { path: 'data_recon/:clientId', type: R },

  AutoAccountWorkflow: { path: 'auto_account_workflow/:clientId', type: R },

  AutoAccountWorkflowResults: { path: 'auto_account_workflow_results/:clientId', type: R },

  AutoAccountAgreements: { path: 'auto_account_agreements/:clientId', type: R },

  RetirementSideBySide: { path: 'retirement-side-by-side/:clientId/:planIds/:goalId', type: R },

  AssetBucketingResults: {
    path: 'asset-bucketing-results/:clientId/:year',
    type: R,
    skipWrapper: true,
  },

  AssetBucketingPreview: { path: 'asset_bucketing_preview', type: R },

  AssetBucketingEdit: { path: 'asset_bucketing_edit/:clientId', type: R },

  Newsfeed: { path: 'newsfeed/:clientId', type: R },

  RightCapital: { path: 'rightcapital/:clientId', type: R },

  BeFi20Workflow: {
    path: 'beFi20/:clientId/workflow',
    type: R,
    skipWrapper: true,
  },

  BeFi20Results: {
    path: 'beFi20/:clientId/results/:compareToId/:isFromSurvey/:isInitiallyComparing',
    type: R,
    skipWrapper: true,
  },

  BeFi20Overview: {
    path: 'beFi20/:clientId/overview',
    type: R,
    skipWrapper: true,
  },

  PulseCheckWorkflow: {
    path: 'pulseCheck/:clientId/workflow',
    type: R,
    skipWrapper: true,
  },

  PulseCheckResults: {
    path: 'pulseCheck/:clientId/results',
    type: R,
    skipWrapper: true,
  },

  PulseCheckSetGoal: {
    path: 'pulseCheck/:clientId/set_goal/:categoryId/:goalId',
    type: R,
    skipWrapper: true,
  },

  GoalTrack: { path: 'goalTrack/:clientId', type: R, skipWrapper: true },

  CustomFormsWorkflow: { path: 'custom-forms-workflow/:clientId', type: R },

  CharitableGivingWorkflow: {
    path: 'charitable-giving-workflow/:clientId/:goalId',
    type: R,
    skipWrapper: false,
  },

  CharitableGivingWorkflowGoals: {
    path: 'charitable-giving-workflow-goals/:clientId',
    type: R,
    skipWrapper: false,
  },
  BeFi: { path: 'befi/:clientId', type: R },
  RiskToleranceResults: { path: 'risk_tolerance_results/:clientId/:redirectTo', type: R },

  PersonalFinanceTemplate: {
    path: 'personal-finance-template/:templateId',
    type: R,
  },
};

ADV.ChartDescriptors = {

    AssetAllocationPortfolioWidget:{
	    chart:{
		    plotBackgroundColor:null,
		    plotBorderWidth:null,
		    plotShadow:false,
		    backgroundColor:'transparent',
		    spacing: [0,0,0,0]
	    },
	    title:{
		    text:''
	    },
	    tooltip:{
		    enabled:true,
		    pointFormat:'{series.name}: <b>{point.percentage:.1f}%</b>'
	    },
	    plotOptions:{
		    pie:{
			    size:'100%',
			    innerSize:'65%',
			    dataLabels:{
				    enabled:false
			    },
			    point: {
				    events: {}
			    }
		    },
		    series: {
			    states: {
				    hover: {
					    enabled: false
				    }
			    }
		    }
	    },
	    series:[
		    {
			    type:'pie',
			    name:'Asset Allocation',
			    data:[]
		    }
	    ],
	    credits:{
		    enabled:false
	    }
    },

	AssetAllocationPortfolioWidget_Overview: {
		chart:{
			plotBackgroundColor:null,
			plotBorderWidth:null,
			plotShadow:false,
			backgroundColor:'transparent',
			spacing: [0,0,0,0]
		},
		title:{
			text:''
		},
		tooltip:{
			enabled:false
		},
		plotOptions:{
			pie:{
				slicedOffset: 0,
				size:'100%',
				innerSize:'90%',
				dataLabels:{
					enabled:false
				},
				point: {
					events: {}
				}
			},
			series: {
				states: {
					hover: {
						enabled: false
					}
				}
			}
		},
		series:[
			{
				type:'pie',
				name:'Asset Allocation',
				data:[]
			}
		],
		credits:{
			enabled:false
		}
	},

    Accounts: {
        chart:{
            plotBackgroundColor:null,
            plotBorderWidth:null,
            plotShadow:false,
            backgroundColor:'transparent'
        },
        title:{
            text:''
        },
        tooltip:{
            enabled:false,
            pointFormat:'{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        plotOptions:{
            pie:{
                size:245,
                innerSize:170,
                dataLabels:{
                    enabled:true,
                    formatter: function() {
                        return '<b>'+ this.point.name +'</b>: '+ Math.round(this.percentage) +' %';
                    },
                    style: {"fontSize":"14px"}
                },
                events: {
                    click: function(event){
                        //select tab
                        $('#accounts-subnav').find('li').each(function(){
                            var $this = $(this);
                            if($this.html() == event.point.name){
                                $this.trigger('click');
                            }
                        });
                    }
                }
            }
        },
        series:[
            {
                type:'pie',
                data:[]
            }
        ],
        credits:{
            enabled:false
        }
    },

    AccountsNetWorth: {
        chart:{
            plotBackgroundColor:null,
            plotBorderWidth:null,
            plotShadow:false,
            backgroundColor:'transparent'
        },
        title:{
            text:''
        },
        tooltip:{
            enabled:false,
            pointFormat:'{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        plotOptions:{
            pie:{
                size:245,
                innerSize:170,
                dataLabels:{
                    enabled:true,
                    formatter: function() {
                        return '<b>'+ this.point.name +'</b>: '+ Math.round(this.percentage) +' %';
                    },
                    style: {"fontSize":"14px"},
                    distance: 8
                },
                events: {
                    click: function(event){
                        //select tab
                        $('#accounts-subnav').find('li').each(function(){
                            var $this = $(this);
                            if($this.html() == event.point.name){
                                $this.trigger('click');
                            }
                        });
                    }
                }
            }
        },
        series:[
            {
                type:'pie',
                data:[]
            }
        ],
        credits:{
            enabled:false
        }
    },

    CashFlowReport: {
        chart: {
            type: 'column',
            events: {
                load: function (e) {
                    var x = this.yAxis[0].tickInterval / 2;
                    this.yAxis[0].update({
                        minorTickInterval: x
                    });
                }
            }
        },
        credits: {
            enabled: false
        },
        title: {
            text: ''
        },
        legend: {
            enabled: false
        },
        xAxis: {
            type: 'category',
            categories: ['Income', 'Expenses'],
            labels: {
                y: 20,
                style: {
                    color: '#6C727F',
                    font: "14px \"Open Sans\",Helvetica,Arial,sans-serif"
                }
            },
            tickWidth: 0
        },
        yAxis: {
            title: {
                text: ''
            },
            gridLineColor: '#dfdfdf',
            labels: {
                format: '${value:,.0f}',
                style: {
                    color: '#bababa',
                    font: "14px \"Open Sans\",Helvetica,Arial,sans-serif"
                },
                tooltip: {
                    enabled: true,
                    useHTML: true,
                    shared: false,
                    crosshairs: false,
                    borderWidth: 1,
                    borderColor: '#71bee4',
                    backgroundColor: '#ffffff',
                    followPointer: true,
                    headerFormat: '',
                    pointFormat: '<span style="font-size: 12px"><b>{point.name}: ${point.y}</b></span>'
                }
            }
        },
        plotOptions: {
            column: {
                lineWidth: 0,
                stacking: 'normal'
            }
        }
    },

    PersonaFinanceReport_CashFlow: {
        chart:{
            plotBackgroundColor:null,
            plotBorderWidth:null,
            plotShadow:false,
            backgroundColor:'transparent'
        },
        title:{
            text:''
        },
        tooltip:{
            enabled:false,
            pointFormat:'{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        plotOptions:{
            pie:{
                size:245,
                innerSize:170,
                dataLabels:{
                    useHTML: true,
                    enabled:true,
                    formatter: function() {
                        var splitted = this.point.name.split("/");
                        return '<div class="chart-label">'+ splitted.join("/ ") +'\xa0'+ Math.round(this.percentage) +'%</div>';
                    },
                    style: {lineHeight:"26px"},
                    distance: 20
                }
            },
            series: {
                cursor: 'pointer'
            }
        },
        series:[
            {
                type:'pie',
                data:[]
            }
        ],
        credits:{
            enabled:false
        }
    },

    NetWorthReport: {
        chart: {
            type: 'column',
            events: {
                load: function (e) {
                    var x = this.yAxis[0].tickInterval / 2;
                    this.yAxis[0].update({
                        minorTickInterval: x
                    });
                }
            }
        },
        credits: {
            enabled: false
        },
        title: {
            text: ''
        },
        legend: {
            enabled: false
        },
        xAxis: {
            type: 'category',
            categories: ['Assets', 'Liabilities'],
            labels: {
                y: 20,
                style: {
                    color: '#6C727F',
                    font: "14px \"Open Sans\",Helvetica,Arial,sans-serif"
                }
            },
            tickWidth: 0
        },
        yAxis: {
            title: {
                text: ''
            },
            gridLineColor: '#dfdfdf',
            labels: {
                enabled: false
                // format: '',
                // style: {
                //     color: '#bababa',
                //     font: "14px \"Open Sans\",Helvetica,Arial,sans-serif"
                // }
            }
        },
        tooltip: {
            enabled: false,
            useHTML: true,
            shared: false,
            crosshairs: false,
            borderWidth: 1,
            borderColor: '#71bee4',
            backgroundColor: '#ffffff',
            followPointer: true,
            headerFormat: '',
            pointFormat: '<span style="font-size: 12px"><b>{point.name}: ${point.y}</b></span>'
        },
        plotOptions: {
            column: {
                lineWidth: 0,
                stacking: 'normal',
                dataLabels: {
                    enabled: false,
                    align: 'center',
                    color: '#FFFFFF',
                    inside: true,
                    crop: false,
                    overflow:"none",
                    style:{
                        width:100,
                        fontFamily: "\"Open Sans\",Helvetica,Arial,sans-serif",
                        fontSize: "17px",
                        fontWeight: "700"
                    },
                    formatter: function() {
                        var point = this.point;
                        setTimeout(function(){
                            point.dataLabel.attr({
                                y: point.plotY + 10
                            });
                        }, 1000);
                        if (this.y === 0) { return "" }
                        return "$" + ADV.util.number_format(this.y, 0);
                    }
                }
            }
        }
    },

	CashReport_Overview: { /* used in ConsumerOverviewOld */
		chart: {
			type: 'column'
		},
		credits: {
			enabled: false
		},
		title: {
			text: ''
		},
		legend: {
			enabled: false
		},
		xAxis: {
			type: 'category',
			labels: {
				y: 20,
				style: {
					color: '#6C727F',
					font: "14px \"Open Sans\",Helvetica,Arial,sans-serif"
				}
			},
			tickWidth: 0
		},
		yAxis: {
			title: {
				text: ''
			},
			gridLineColor: '#dfdfdf',
			labels: {
				format: '${value:,.0f}',
				style: {
					color: '#bababa',
					font: "14px \"Open Sans\",Helvetica,Arial,sans-serif"
				}
			}
		},
		tooltip: {
			enabled: true,
			useHTML: true,
			shared: false,
			crosshairs: false,
			borderWidth: 1,
			borderColor: '#71bee4',
			backgroundColor: '#ffffff',
			followPointer: true,
			headerFormat: '',
			pointFormat: '<span style="font-size: 12px"><b>{point.name}: ${point.y}</b></span>'
		},
		plotOptions: {
			column: {
				lineWidth: 0
			}
		}
	},

    NetWorthCombinedReport: { /* used in Reports */
        chart: {
            type: 'column',
            events: {
                load: function (e) {
                    var x = this.yAxis[0].tickInterval / 2;
                    this.yAxis[0].update({
                        minorTickInterval: x
                    });
                }
            }
        },
        credits: {
            enabled: false
        },
        title: {
            text: ''
        },
        legend: {
            enabled: false
        },
        xAxis: {
            type: 'category',
            categories: ['Assets', 'Liabilities'],
            lineColor: '#333333',
            lineWidth: 2,
            labels: {
                y: 20,
                style: {
                    color: '#6C727F',
                    font: "14px \"Open Sans\",Helvetica,Arial,sans-serif"
                }
            },
            tickWidth: 0
        },
        yAxis: {
            title: {
                text: ''
            },
            gridLineColor: '#dfdfdf',
            labels: {
                enabled: true,
                formatter: function () {
                    if (this.value >= 1000000) { return '$' + (this.value / 1000000).toFixed(1).replace(/\.0$/, '') + 'M'; }
                    if (this.value >= 1000) { return '$' + (this.value / 1000).toFixed(1).replace(/\.0$/, '') + 'K'; }
                    if (this.value === 0) { return '$0'; }
                    if (this.value <= -1000000) { return '($' + ((this.value / 1000000) * -1).toFixed(1).replace(/\.0$/, '') + 'M)'; }
                    if (this.value <= -1000) { return '($' + ((this.value / 1000) * -1).toFixed(1).replace(/\.0$/, '') + 'K)'; }

                }
            }
        },
        tooltip: {
            useHTML: true,
            shared: true,
            shadow: false,
            borderWidth: 0,
            backgroundColor: "rgba(255,255,255,0)",
            borderRadius: 0,
            formatter: function() {
                return (
                    '<div class="NetWorthHistoryTooltip">' +
                    '<div class="key">' + this.x + '</div>' +
                    '<div class="networth" style="color:' + this.points[2].series.color + '">' + ADV.util.number_format(this.points[2].y) + '</div>' +
                    '<div class="asset" style="color:' + this.points[0].series.color + '">' + ADV.util.number_format(this.points[0].y) + '</div>' +
                    '<div class="liability" style="color:' + this.points[1].series.color + '">' + ADV.util.number_format((this.points[1].y * -1)) + '</div>' +
                    '</div>'
                );
            }
        },
        plotOptions: {
            column: {
                lineWidth: 0,
                stacking: 'normal',
                dataLabels: {
                    enabled: true,
                    align: 'center',
                    color: '#FFFFFF',
                    inside: true,
                    crop: false,
                    overflow:"none",
                    style:{
                        width:100,
                        fontFamily: "\"Open Sans\",Helvetica,Arial,sans-serif",
                        fontSize: "17px",
                        fontWeight: "700"
                    },
                    formatter: function() {
                        var point = this.point;
                        setTimeout(function(){
                            point.dataLabel.attr({
                                y: point.plotY + (point.y < 0 ? -40 : 10)
                            });
                        }, 1000);
                        if (this.y === 0) { return "" }
                        return this.y < 0 ? "($" + ADV.util.number_format(this.y * -1, 0) + ")" :
                            "$" + ADV.util.number_format(this.y, 0);
                    }
                }
            }
        }
    },

    PersonalFinanceAccountReport: {
        chart: {
            type: 'line'
        },
        credits: {
            enabled: false
        },
        title: {
            text: ''
        },
        legend: {
            enabled: false
        },
        xAxis: {
            type: 'category',
            labels: {
                y: 20,
                style: {
                    color: '#6C727F',
                    font: "14px \"Open Sans\",Helvetica,Arial,sans-serif"
                }
            },
            tickWidth: 0
        },
        yAxis: {
            title: {
                text: ''
            },
            gridLineColor: '#dfdfdf',
            labels: {
                format: '${value:,.0f}',
                style: {
                    color: '#bababa',
                    font: "14px \"Open Sans\",Helvetica,Arial,sans-serif"
                }
            }
        },
        tooltip: {
            enabled: true,
            useHTML: true,
            shared: false,
            crosshairs: false,
            borderWidth: 1,
            borderColor: '#71bee4',
            backgroundColor: '#ffffff',
            followPointer: true,
            headerFormat: '',
            pointFormat: '<span style="font-size: 12px"><b>{point.name}: ${point.y}</b></span>'
        }
    }
};

var ADV = (function(app) {
  app.HelpDescriptors = {
    GetStarted: {
      title: 'Getting Started',
      description:
        'Add a client to start using Orion Planning.<span style="display:block;margin:15px 0 0 0;font-weight:700;">Come back here for helpful tips!</span>',
    },

    dashboard: {
      title: 'Dashboard',
      description:
        'The Dashboard provides an aggregate view of your top clients by assets, external assets, as well as life insurance opportunities. Use the panel on the left to create a new client or to search for existing clients.',
    },

    PersonalInfoStep: {
      title: 'Personal Information',
      description:
        'Begin the wizard by entering the household members including Spouse and any dependent children.',
    },

    GoalSelectionStep: {
      title: 'Goals',
      description:
        'Goals are the centerpiece of the financial plan. Select the ones that matter most.',
    },

    AccountLinkingStep: {
      title: 'Account Links',
      description:
        'Automatically import investment account balances and portfolio asset allocation.',
    },

    Accounts: {
      title: 'Accounts',
      description:
        'Enter/import financial accounts. Make sure to enter portfolio asset allocations, earmarks, and monthly contributions to create a baseline for the financial plan. Below are some supported account types: ' +
        '<ul><li>Checking</li><li>Savings</li><li>CD</li><li>Investment</li><li>401k/403(b)/457/IRA/Roth/SEP</li><li>Fixed Annuitiy</li><li>Credit Card</li><li>Installment Loans</li><li>Line of Credit</li><li>Student Loan</li><li>Mortgage</li></ul>',
    },

    OtherAssets: {
      title: 'Other Assets',
      description:
        'In this section, please include any other non-institutional assets you may have. Include such items as business assets, real estate, pensions, car, motorcycle, valuable artwork/jewelery, etc.',
    },

    InsuranceStep: {
      title: 'Insurance',
      description:
        'Enter any life insurance, disability insurance, or long-term care insurance policies.',
    },

    IncomeStep: {
      title: 'Income',
      description:
        'Please specify all incomes, including employment, business and real estate incomes, or social security incomes. You can also specify an expected other future income, such as an inheritance or a sale of your business.',
    },

    ExpensesStep: {
      title: 'Expenses',
      description:
        'Expenses can be entered as a single total monthly amount, or as a breakdown of expenses by category. Add as many categories as you want. To enter a custom category, use select "Other" in the Type dropdown menu.',
    },

    FutureExpensesStep: {
      title: 'Future Expenses',
      description:
        'Specify any expected large expenses in the future, such as buying a car or a home renovation. You can also specify recurring expenses.',
    },

    RiskToleranceStep: {
      title: 'Risk Tolerance',
      description:
        'Specify the risk tolerance, which will determine a matching investment portfolio for your goals.',
    },

    TaxFilingStep: {
      title: 'Tax Filing',
      description:
        'If you specify the tax filing state and status, we will estimate taxes based on your income. Alternatively, you can specify an effective tax rate. <a href="https://help.advizr.com/financial-planning/2019-tax-updates" target="_blank">See how Advizr calculates income taxes</a>.',
    },

    DocumentVault: {
      title: 'Document Vault',
      description:
        'Share documents with your advisor, such as tax documents, loan filings or other pertinent requested materials.',
    },

    FinancialPlan: {
      title: 'Financial Plan',
      description:
        "This financial plan summarizes the recommendation for each goal. Click on the dropdown, or use the buttons at the bottom, to navigate across the goals.<br><br>To edit your recommendations for a particular goal, click the 'What-Ifs' button at the top right. This will open the What-Ifs widget.<br><br>To reset the Financial Plan, click the 'Reset' button in the top right. If you cannot find the 'Reset' button, click 'What-Ifs' first.",
    },

    AccountsReport: {
      title: 'Accounts Report',
      description:
        'This section displays a summary of all of the accounts aggregated into one chart, and/or into separate charts for cash, investments and real estate with respective breakdowns for individual accounts.  A further segmentation can be provided to display accounts by type, goal, ownership and tax status.',
    },

    AssetAllocationReport: {
      title: 'Asset Allocation',
      description:
        "This report shows the client's overall asset allocation, broken down by owner, goal, institution, ownership or tax status.",
    },

    NetWorthReport: {
      title: 'Net Worth Report',
      description:
        'This report displays the overall net worth, segmented into overall assets and liabilities. Click on each section to expand and view more details.',
    },

    ProjectedCashFlowReport: {
      title: 'Projected Cash Flow Report',
      description:
        "This report displays the clients' projected cash flows, inclusive of all inputs and outputs, from today to plan-end, and is filterable by 'current situation' or 'proposed plan'.  Click on a section to expand and view more detailed cash flow items. Also, use the menu on the top right for easy access to a specific milestone.",
    },
  };
  return app;
})(ADV || {});

var ADV = (function (app) {
    app.tooltip_tours = {


    };

    return app;

})(ADV || {});
/* eslint-disable @typescript-eslint/camelcase */

ADV.tooltip_callouts = {
  AdviserSearchClient: {
    Welcome: {
      html:
        'Alight users can use the search operators, "organization" and "alightid" to further specify their search. For example, "organization:FedEx Dave Smith", "alightid:2700062". Combinations searches may also be used. For example, "organization:fedex organization:Huntington jane" will return all clients whose name starts with "jane" AND are in the organization Fedex OR organization Huntington Ingalls.',
      orientation: 'right',
    },
  },

  RetirementAssetsChart: {
    Current: {
      html: 'Based on information entered in the Profile section',
      orientation: 'left',
    },
    ProposedPlan: {
      html: 'Based on information entered in the What-Ifs fields above',
      orientation: 'left',
    },
    ProposedPlanOverview: {
      html: 'Based on information entered in the What-Ifs fields from the recommendations page',
      orientation: 'left',
    },
  },

  FinancialPlan: {
    TooltipCurrent: {
      orientation: 'left',
    },
    TooltipRecommended: {
      orientation: 'left',
    },
  },

  FinancialPlan_Recommandations: {
    RetirementAssets_CurrentLabel: {
      html: 'Based on information entered in the Profile section',
      orientation: 'left',
    },
    RetirementAssets_ProposedLabel: {
      html: 'Based on information entered in the What-Ifs fields above',
      orientation: 'left',
    },
    DebtManagement_CurrentLabel: {
      html: 'Based on information entered in the Profile section',
      orientation: 'left',
    },
    DebtManagement_ProposedLabel: {
      html: 'Based on information entered in the What-Ifs fields above',
      orientation: 'left',
    },
    ActionNeededLabel: {
      html:
        'Action Needed indicates there are Action Steps listed below that have not yet been checked off as done.',
      orientation: 'right',
    },
    OnTrackLabel: {
      html: 'On Track indicates that there are no incomplete Action Steps listed below.',
      orientation: 'right',
    },
  },

  EditAccount_RealEstate: {
    MonthlyPayment: {
      html:
        'Monthly payment includes principal and interest. Real estate taxes, condos fees, home owners insurance can be added in the Expenses step.',
      orientation: 'right',
    },
    YearlyRentalIncome: {
      html: 'This is your net income from the property.',
      orientation: 'right',
    },
  },

  Income_Add: {
    EmploymentAmount: {
      html:
        "Enter your total income before deducting taxes, benefits, FICA, contributions, etc. in today's dollars.",
      orientation: 'right',
    },
    OtherAmount: {
      html: "Please specify the amount before deducting taxes in today's dollars.",
      orientation: 'right',
    },
    StartAtAge: {
      html:
        'Enter the age of the Earner when the income will start. To start this income immediately, leave this field blank.',
      orientation: 'right',
    },
    EndsAtAge: {
      html:
        'Enter the age of the Earner when the income will stop. To stop this income at retirement, leave this field blank.',
      orientation: 'right',
    },
    Inflation: {
      html:
        'Enter the inflation rate applied to the Salary field. Leave this field blank to use the global "Income Growth Rate" found in Settings.',
      orientation: 'right',
    },
    TaxFree: {
      html:
        'If checked, this income will be free of federal and state taxes (e.g. Military combat pay). By default employment incomes are taxed.',
      orientation: 'right',
    },
    SECATax: {
      html: 'Applies SECA tax and deducts half the amount from pre-tax profit.',
      orientation: 'right',
    },
    YearlyTaxableAmount: {
      html: 'Enter a taxable amount if the amount to be taxed is different from the yearly amount.',
      orientation: 'right',
    },
  },

  Profile_Accounts_Form_InheritedIRA: {
    DistributionSchedule: {
      html:
        'List distribution percentages for each year between the current year and the 10th year after inheritance. ' +
        'For example, entering 80, 20, followed by 0 values for subsequent years indicates distribution 80% of the ' +
        'balance in the first year and the remaining 20% in the second year, while 20, 20, 20, 20, 20, followed by 0 values ' +
        'for subsequent years would distribute 20% each year for 5 years.',
      orientation: 'right',
    },
  },

  PmiField: {
    html:
      'Private mortgage insurance, also called PMI, is a type of mortgage insurance you might be required to pay for if you have a conventional loan. Like other kinds of mortgage insurance, PMI protects the lender if you stop making payments on your loan.',
    orientation: 'right',
  },

  FinancialAccounts_Add: {
    Nickname: {
      // invoked manually via API
      target: 'input[name="AccountName"]',
      html: "This will help you easily identify this account wherever it's shown.",
      orientation: 'right',
    },
  },

  Profile_Accounts_Edit: {
    ShowAccount: {
      html:
        'If disabled, the account will be excluded from the Accounts list and the Financial Plan.',
      orientation: 'right',
    },
    AccountEarmark: {
      html: 'Please select the goal(s) you will fund with this specific account.',
      orientation: 'right',
    },
  },
  Profile_Accounts_Form_FixedAnnuity: {
    SurrenderSchedule: {
      html:
        'Enter the Surrender Schedule starting from the first contract year in the following comma separated format: 15%, 15%, 15%, 15%, 12.86%, 10.71%, 8.57%, 6.43%, 4.29%, 2.14%. In this example, there is a 15% surrender charge applied during the first year of the annuity based on the Purchase Year field.',
      orientation: 'right',
    },
  },
  Profile_Accounts_Form_Brokerage: {
    TurnoverRatio: {
      html: 'Percentage of portfolio that is realized and taxed annually.',
      orientation: 'right',
    },
    CapitalGainsRatio: {
      html: 'Percentage of portfolio taxed at long-term capital gains rate.',
      orientation: 'right',
    },
  },

  Profile_Accounts_Form_Annuity: {
    AnnuityLivingBenefitRider: {
      CurrentBenefitBase: {
        html: 'The benefit base is used to calculate the guaranteed minimum income',
        orientation: 'right',
      },
      RollUpRate: {
        html: 'The rate at which the benefit base grows',
        orientation: 'right',
      },
      WithdrawalBenefit: {
        html: 'The percentage of the benefit base that is withdrawn as income',
        orientation: 'right',
      },
    },
  },

  Profile_Accounts_Insurance_Policy: {
    LifeInsurance: {
      html: 'The rate the market value for the policy grows.',
      orientation: 'right',
    },
  },

  LinkAccount_Form: {
    FinancialInstitution: {
      html: "Can't find your institution? Please contact Customer Support to add it to the list.",
      orientation: 'right',
    },
  },

  ConsumerOverview: {
    Reset: {
      html: 'Reset to auto-generated Action Steps',
      orientation: 'top',
      hoverOnly: true,
    },
    Remove: {
      html: 'Remove',
      orientation: 'top',
      hoverOnly: true,
    },
    MarkAsDone: {
      html: 'Mark as Done',
      orientation: 'top',
      hoverOnly: true,
    },
    MarkAsNotDone: {
      html: 'Mark as Not Done',
      orientation: 'top',
      hoverOnly: true,
    },
  },

  SocialSecurity: {
    PIA: {
      html: 'Estimates monthly PIA from current income.',
      orientation: 'right',
      hoverOnly: true,
    },
    MonthlyPIA: {
      html:
        'The Primary Insurance Amount (PIA) is the benefit a person would receive if he/she elects to begin receiving retirement benefits at his/her Full Retirement Age (FRA). Estimates are also available from the Social Security Administration at https://www.ssa.gov/.',
      orientation: 'right',
      hoverOnly: true,
    },
    StartsAtAge: {
      html: 'Age will be used to calculate monthly retirement benefit based on monthly PIA.',
      orientation: 'right',
      hoverOnly: true,
    },
  },

  DebtManagement: {
    DebtRepaymentStrategy: {
      orientation: 'right',
      hoverOnly: true,
      html:
        'Additional payments chosen in the Cash Flow section will be put toward one loan at a time. For example, if you ' +
        'choose "Highest Interest Rate First", the loan that has the highest interest rate will be paid off until it is ' +
        'completely paid down. Then, the next highest interest rate loan will be paid off, and so on.',
    },
  },

  Expenses: {
    EstimateExpense: {
      orientation: 'right',
      hoverOnly: true,
      html:
        'Estimate your expenses for this category based on historical data available from your linked accounts.',
    },
  },

  Insurance: {
    AssetsRunOut: {
      orientation: 'right',
      hoverOnly: true,
      html:
        "The age at which the surviving partner will run out of assets based on investable assets, the survivor's income and current life insurance coverage.",
    },
    CurrentCoverage: {
      orientation: 'right',
      hoverOnly: true,
      html:
        'The current coverage combines existing life insurance with additional coverage specified in the what-ifs section.',
    },
  },
  Contribution: {
    EndYear: {
      html:
        "With plan default, contributions automatically end when the account's earmarked goal starts. However, if an account is not earmarked to any goal, contributions will continue until the end of plan.",
      orientation: 'right',
    },
  },
  Account: {
    Fees: {
      html:
        'This fee will reduce the investment return to represent account management and investment related fees. For example, if the account return is 7% and you enter 1% for the account fee, your net return will be 6%.',
      orientation: 'right',
      hoverOnly: true,
    },
    FeesAnnuity: {
      html:
        'This fee will reduce the investment return to represent account management and investment related fees. This account fee should also include any fees associated with M&E Expenses and Riders. For example, if the account return is 7% and you enter 2% for the account fee, your net return will be 5%.',
      orientation: 'right',
      hoverOnly: true,
    },
  },

  DebtManagementChart: {
    Current: {
      html: 'Based on information entered in the Profile section',
      orientation: 'left',
    },
    ProposedPlan: {
      html: 'Based on information entered in the What-Ifs fields above',
      orientation: 'left',
    },
    ProposedPlanOverview: {
      html: 'Based on information entered in the What-Ifs fields from the recommendations page',
      orientation: 'left',
    },
  },
};

/* global ADV */
/*
    eslint-disable
    func-names,
    no-param-reassign,
*/

window.ADV = (function (app) {
  app.init = function (callback) {
    return new Promise((resolve) => {
      // app is ready!
      if (typeof callback === 'function') {
        callback.call();
      }
      resolve();
    });
  };

  return app;
}(window.ADV || {}));

/*
    eslint-disable
    func-names,
    no-param-reassign,
    prefer-rest-params,
*/

ADV.util = (function(my) {
  /**
   * Combines close together signals into one.
   * @param func
   * @param wait
   * @param {boolean=} runFirst
   * @return {Function}
   */
  my.debounce = function(func, wait, runFirst) {
    let timeout;
    return function() {
      const context = this;
      const args = arguments;
      const later = function() {
        timeout = null;
        if (!runFirst) {
          func.apply(context, args);
        }
      };
      const callNow = runFirst && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) {
        func.apply(context, args);
      }
    };
  };

  my.throttle = function(func, threshhold, scope) {
    threshhold || (threshhold = 250);
    let last;
    let deferTimer;
    return function() {
      const context = scope || this;

      const now = +new Date();
      const args = arguments;
      if (last && now < last + threshhold) {
        // hold on to it
        clearTimeout(deferTimer);
        deferTimer = setTimeout(() => {
          last = now;
          func.apply(context, args);
        }, threshhold);
      } else {
        last = now;
        func.apply(context, args);
      }
    };
  };

  my.guid = function() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = (Math.random() * 16) | 0;
      const v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };

  my.dispatchHTMLEvent = function(element, event) {
    if ('createEvent' in document) {
      var e = document.createEvent('HTMLEvents');
      e.initEvent(event, false, true);
      element.dispatchEvent(e);
    } else {
      var e = document.createEventObject();
      e.eventType = event;
      element.fireEvent(`on${e.eventType}`, e);
    }
  };

  my.getHash = function() {
    if (window.location.hash) {
      return window.location.hash.substring(1);
    }
    return false;
  };

  my.scrollToTop = function(duration) {
    duration = duration === 0 ? 0 : 300;
    jQuery('html,body').animate({ scrollTop: 0 }, duration);
  };

  my.scrollTo = function(top, duration) {
    duration = duration === undefined ? 300 : duration;
    jQuery('html,body').animate({ scrollTop: top }, duration);
  };

  /**
   * Returns true if thing is an empty array, empty object, undefined or null.
   * @param thing
   */
  my.isEmpty = function(thing) {
    if (typeof thing === 'undefined' || thing === null) {
      return true;
    }
    if (typeof thing === 'array' && thing.length === 0) {
      return true;
    }
    return $.isEmptyObject(thing);
  };

  my.go2 = function(loc) {
    window.location = loc;
  };

  my.supportsLocalStorage = function() {
    const test = 'advizr';
    try {
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      return true;
    } catch (e) {
      return false;
    }
  };

  /**
   * Returns HTML string of errors, which could be a string, array, or object mapping. The result to be shown in a
   * popup, or 500 page.
   * @param errors
   */
  my.getErrorsHTMLFromResponse = function(errors) {
    let errorString = '';
    if (typeof errors === 'string') {
      return errors;
    }
    if ($.isArray(errors) && errors.length === 1) {
      return errors[0];
    }
    if (errors instanceof Object && Object.keys(errors).length === 1) {
      $.each(errors, (k, v) => {
        errorString = v;
      });
      return errorString;
    }
    if (
      ($.isArray(errors) && errors.length > 1) ||
      (errors instanceof Object && Object.keys(errors).length > 1)
    ) {
      errorString = '<ul>';
      $.each(errors, (k, v) => {
        errorString += `<li>${v}</li>`;
      });
      return `${errorString}</ul>`;
    }
    return ADV.settings.MsgLib.generic_error;
  };

  my.validateEmail = function(email) {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };

  /**
   * @param number
   * @param decimals //number of decimal places, defaults to 0
   * @param dec_point //defaults to .
   * @param thousands_sep //defaults to ,
   * @returns {string|*}
   */
  my.number_format = function(number, decimals, dec_point, thousands_sep) {
    number = `${number}`.replace(/[^0-9+\-Ee.]/g, '');
    const n = !isFinite(+number) ? 0 : +number;
    const prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
    const sep = typeof thousands_sep === 'undefined' ? ',' : thousands_sep;
    const dec = typeof dec_point === 'undefined' ? '.' : dec_point;
    let s;
    const toFixedFix = function(n, prec) {
      const k = Math.pow(10, prec);
      return `${Math.round(n * k) / k}`;
    };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : `${Math.round(n)}`).split('.');
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || '';
      s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
  };

  /**
   * Converts formatted number strings back to integers
   * @param val
   * @returns {*}
   */
  my.as_number = function(val) {
    if (!val) {
      return 0;
    }
    if (typeof val === 'number') {
      return val;
    }
    return parseInt(val.split(',').join(''), 10);
  };

  /**
   * Determines whether the key input was numeric. Also allows
   * modifiers and navigational keypresses
   * @param keyCode
   * @returns {boolean}
   */
  my.numeric_input = function(keyCode) {
    return (
      (keyCode >= 48 && keyCode <= 57) ||
      (keyCode >= 96 && keyCode <= 105) ||
      keyCode === 8 ||
      keyCode === 9 ||
      keyCode === 46 ||
      keyCode === 37 ||
      keyCode === 39 ||
      keyCode === 16
    );
  };

  /**
   * Determines whether the key input was a modifier or navigational keypress
   * @param keyCode
   * @returns {boolean}
   */
  my.is_navigational_input = function(keyCode) {
    return (
      keyCode === 8 ||
      keyCode === 9 ||
      keyCode === 46 ||
      keyCode === 37 ||
      keyCode === 39 ||
      keyCode === 16
    );
  };

  /**
   * shades a color based on a percentage
   * @param color
   * @param percent
   * @returns {string}
   */
  my.shade_color = function(color, percent) {
    const f = parseInt(color.slice(1), 16);
    const t = percent < 0 ? 0 : 255;
    const p = percent < 0 ? percent * -1 : percent;
    const R = f >> 16;
    const G = (f >> 8) & 0x00ff;
    const B = f & 0x0000ff;
    return `#${(
      0x1000000 +
      (Math.round((t - R) * p) + R) * 0x10000 +
      (Math.round((t - G) * p) + G) * 0x100 +
      (Math.round((t - B) * p) + B)
    )
      .toString(16)
      .slice(1)}`;
  };

  /**
   * Takes a large number, and shortens it using postfixes. Ex:
   * 1000000 => 1M, 10000 => 10K, 10843 => 10.8K
   * Supports up to trillions (T).
   * @param number //must be a number
   * @param decimals //default is 2
   */
  my.short_number_format = function(number, decimals, lang = ['', 'K', 'M', 'B', 'T']) {
    decimals = typeof decimals !== 'undefined' && decimals >= 0 ? parseInt(decimals) : 2;
    const n = Math.round(number).toString();
    const len = n.length;
    const index = Math.floor((len - 1) / 3);
    const ll = lang.length;
    const i = index < ll ? index : ll - 1; // max is lang.length - 1
    const wlen = len - 3 * i;
    const dec = parseFloat(`0.${n.substr(wlen, decimals)}`);
    const num = parseInt(n.substr(0, wlen));
    const tot = num + dec;
    const fixed = Number.parseFloat(tot)
      .toFixed(decimals)
      .replace(/[.]0+$/, '');
    const formatted = fixed.indexOf('.') >= 0 ? fixed.replace(/0+$/, '') : fixed;
    return formatted + lang[i];
  };

  my.randomString = function(length) {
    length = length || 5;
    let text = '';
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    for (let i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return text;
  };

  /**
   * Makes $el stick to the top of the window. You must call the returned 'destroy' function to free
   * resources when done. $el should be a container for the actual element you want to be sticky.
   * @param $el
   * @param top // Defaults to 50 if within Adviser Area, 0 otherwise.
   * @param callback //called whenever the status changes (sticky on, sticky off). Called with boolean, with true
   *                 //representing the 'on' state, and false representing the 'off' state.
   * @returns {{destroy: destroy}}
   */
  my.makeSticky = function($el, callback, top, bindWidth) {
    if (!$el.length) {
      throw '$el is not a valid jQuery object, or is empty';
    }
    callback = callback || function() {};
    top = top || 0;
    if ($('html').hasClass('area-adviser')) {
      if (top < 50) {
        top = 50;
      }
    }
    // create unique namespace for events, so they can be bound/unbound individually
    const namespace = my.randomString();
    const $window = $(window);
    let is_sticky = false;
    const $child = $el.find('> *');
    const events = `scroll.${namespace} resize.${namespace}`;
    const stickyOnCSS = {
      width: bindWidth || $el.innerWidth(),
      position: 'fixed',
      backfaceVisibility: 'hidden',
      top: `${top}px`,
    };
    const stickyOffCSS = {
      width: '',
      position: '',
      top: '',
    };

    $window.on(
      events,
      ADV.util.throttle(() => {
        if ($window.scrollTop() >= $el.offset().top - top) {
          // set styles to prevent jumping, and so that $item > * is still sized relative to container instead
          // of window
          $el.css('height', $el.innerHeight());
          $child.css(stickyOnCSS);
          $el.addClass('sticky-on');
          if (!is_sticky) {
            callback.call($el, true);
          }
          is_sticky = true;
        } else {
          // restore styles
          $el.css('height', '');
          $child.css(stickyOffCSS);
          $el.removeClass('sticky-on');
          if (is_sticky) {
            callback.call($el, false);
          }
          is_sticky = false;
        }
      }, 50),
    );

    return {
      destroy() {
        $window.off(`scroll.${namespace} resize.${namespace}`); // unbind event observer
      },
    };
  };

  my.getCurrentClient = function(advData) {
    if (!advData) {
      throw 'getBaseConsumerAreaBaseRoute: ADV.data is not initialized!';
    }

    if (!advData.user) {
      throw 'getBaseConsumerAreaBaseRoute: ADV.data.user is not initialized!';
    }
    return advData.user;
  };

  my.getNullableCurrentClient = function(advData) {
    try {
      return my.getCurrentClient(advData);
    } catch (_) {
      return null;
    }
  };

  /**
   * Environment detection. Returns information about the browser, OS, ADV master Area, etc.
   * Caches results the first time they are tested, unless bustCache is true (defaults to false).
   * Possible keywords:
   * isChrome, isSafari, isiOS, isMac, isConsumerArea, isAdviserArea, isPrintArea
   * @param test
   * @param {boolean=} bustCache //defaults to false
   * @returns {*}
   */
  my.env = function(test, bustCache) {
    const tests = {};
    const cache = ADV.util.envCache || {};
    tests.isChrome = function() {
      return /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    };
    tests.isSafari = function() {
      return /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
    };
    tests.isiOS = function() {
      return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    };
    tests.isMac = function() {
      return navigator.platform.toUpperCase().indexOf('MAC') >= 0;
    };
    tests.isConsumerArea = function() {
      return $('html').hasClass('area-consumer');
    };
    tests.isAdviserArea = function() {
      return $('html').hasClass('area-adviser');
    };
    tests.isPrintArea = function() {
      return $('html').hasClass('area-print');
    };
    tests.isDemoMode = function() {
      return $('html').hasClass('DemoMode');
    };

    // make sure test exists
    if (typeof tests[test] === 'undefined') {
      throw `test '${test}' is not defined in ADV.util.env`;
    }

    if (typeof cache[test] === 'undefined' || bustCache) {
      // do test and cache
      cache[test] = tests[test].apply();
      ADV.util.envCache = cache; // save cache
    }

    return cache[test];
  };

  /**
   * @param str
   * @param maxlen
   * @param ellipse
   * @returns {*}
   */
  my.truncateString = function(str, maxlen, ellipse) {
    maxlen = maxlen || 20;
    ellipse = ellipse || '...';
    return str.length > maxlen ? str.substring(0, maxlen - 3) + ellipse : str;
  };

  /**
   * Returns true of all of the properties of objA have matching properties in objB. Uses a shallow iterator, so it only looks
   * at the immediate properties, and does not traverse any further. Use strict to use '===' comparison, otherwise
   * '==' is used.
   * @param objA
   * @param objB
   * @param strict
   * @returns {boolean}
   */
  my.shallowCompareObjects = function(objA, objB, strict) {
    let is_equal = true;
    $.each(objA, (k, v) => {
      if (strict) {
        if (v !== objB[k]) {
          is_equal = false;
        }
      } else if (v != objB[k]) {
        is_equal = false;
      }
    });
    return is_equal;
  };

  my.deepEqual = function(A, B, strict) {
    const eq = function(u, v) {
      const isUArray = Array.isArray(u);
      const isVArray = Array.isArray(v);
      if (isUArray !== isVArray) {
        return false;
      }
      if (isVArray) {
        return eqArrays(u, v);
      }

      const isUObject = typeof u === 'object';
      const isVObject = typeof v === 'object';
      if (isUObject !== isVObject) {
        return false;
      }
      if (isVObject) {
        return eqObjects(u, v);
      }
      return strict ? u === v : u == v;
    };

    var eqArrays = function(u, v) {
      if (!u || !v) {
        return strict ? u === v : u == v;
      }
      if (u.length !== v.length) {
        return false;
      }
      for (let i = 0, l = u.length; i < l; i++) {
        if (!eq(u[i], v[i])) {
          return false;
        }
      }
      return true;
    };

    var eqObjects = function(x, y) {
      if (!x || !y) {
        return strict ? x === y : x == y;
      }
      for (const k in x) {
        if (x.hasOwnProperty(k)) {
          if (!y.hasOwnProperty(k)) {
            return false;
          }
          if (!eq(x[k], y[k])) {
            return false;
          }
        }
      }
      return true;
    };

    return eq(A, B);
  };

  /**
   * @param $tabs_ul
   */
  my.setupTabs = function($tabs_ul) {
    const $li = $tabs_ul.find('li');

    // if there is only one tab, hide tabs.
    if ($li.length <= 1) {
      // hide tabs
      $tabs_ul.css('display', 'none');
    } else {
      // set width of LI of tabs
      $li.css('width', `${100 / ($li.length * 1)}%`);
    }

    $tabs_ul.on('click', 'li', function() {
      $li.removeClass('selected');
      $(this).addClass('selected');
    });
  };

  /**
   * Enables or disables the 'empty_state' styling for the Adviser Area
   * @param show
   */
  my.showAdviserAreaEmptyState = function(show) {
    const $html = $('html');
    if (show) {
      $html.addClass('empty-state');
    } else {
      $html.removeClass('empty-state');
    }
  };

  /**
   * Shows or hides the consumer area topleft nav.
   * @param val
   */
  my.showConsumerAreaNav = function(val) {
    ADV.consumer.set_workflow(!val);
  };

  my.toggleFullScreen = function() {
    if (
      !document.fullscreenElement && // alternative standard method
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement &&
      !document.msFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.msRequestFullscreen) {
        document.documentElement.msRequestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      }
    } else if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    }
  };

  /**
   * Returns the Client Model for a given clientId. If in the Adviser Area, this is taken from the SidebarWidget, since it has
   * all of the the Adviser's clients. If we're in the Consumer Area, the current user is returned, if it matches the clientId
   * provided.
   * @param clientId
   * @returns {*}
   */
  my.getClient = function(clientId) {
    if (ADV.util.env('isAdviserArea')) {
      return _.get(ADV.store.getState(), 'AdviserArea.currentClient');
    }
    if (ADV.util.env('isConsumerArea')) {
      // see if current user's ID matches clientId
      const current_user = ADV.entities.getUserObject();
      if (current_user.Id == clientId) {
        return current_user;
      }
      return false;
    }
    return false;
  };

  my.getCurrentClientId = function() {
    if (ADV.util.env('isAdviserArea')) {
      return ADV.entities.getCurrentClientId();
    }
    if (ADV.util.env('isConsumerArea')) {
      return ADV.entities.getUserObject().Id || false;
    }
    return false;
  };

  /**
   * Computes the offset of the body element
   * @returns {{top: Number, left: Number}}
   */
  my.bodyOffset = function(body) {
    let top = body.offsetTop;
    let left = body.offsetLeft;
    const doesNotIncludeMarginInBodyOffset = body.offsetTop !== 1;
    if (doesNotIncludeMarginInBodyOffset) {
      top += parseFloat(body.getAttribute('marginTop')) || 0;
      left += parseFloat(body.getAttribute('marginLeft')) || 0;
    }
    return { top, left };
  };

  /**
   * Tests if the object is the current window object
   * @returns {Boolean}
   */
  my.isWindow = function(obj) {
    return obj != null && obj == obj.window;
  };

  /**
   * Gets the current window element
   * @returns {Boolean | *}
   */
  my.getWindow = function(elem) {
    return my.isWindow(elem)
      ? elem
      : elem.nodeType === 9
      ? elem.defaultView || elem.parentWindow
      : false;
  };

  /**
   * Returns the offset of the domElement
   * @returns {{top: Number, left: Number} | null}
   */
  my.getOffset = function(domElement) {
    let box;
    let docElem;
    let body;
    let win;
    let clientTop;
    let clientLeft;
    let scrollTop;
    let scrollLeft;
    let top;
    let left;
    const elem = domElement;
    const doc = elem && elem.ownerDocument;

    if (!doc) {
      return null;
    }

    if ((body = doc.body) === elem) {
      return my.bodyOffset(elem);
    }
    docElem = doc.documentElement;

    box = elem.getBoundingClientRect();
    win = my.getWindow(doc);
    clientTop = docElem.clientTop || body.clientTop || 0;
    clientLeft = docElem.clientLeft || body.clientLeft || 0;
    scrollTop = win.pageYOffset || docElem.scrollTop;
    scrollLeft = win.pageXOffset || docElem.scrollLeft;
    top = box.top + scrollTop - clientTop;
    left = box.left + scrollLeft - clientLeft;

    return { top, left };
  };

  my.getCss = function(elem, attribute) {
    return window.getComputedStyle(elem)[attribute];
  };

  my.isNodeName = function(elem, name) {
    return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
  };

  my.getOffsetParent = function(elem) {
    let offsetParent = elem.offsetParent || elem;

    while (
      offsetParent &&
      !my.isNodeName(offsetParent, 'html') &&
      my.getCss(offsetParent, 'position') === 'static'
    ) {
      offsetParent = offsetParent.offsetParent;
    }
    return offsetParent || elem;
  };

  my.getPosition = function(elem) {
    if (!elem) {
      return;
    }

    let offsetParent;
    let offset;
    let parentOffset = {
      top: 0,
      left: 0,
    };

    // fixed elements are offset from window (parentOffset = {top:0, left: 0}, because it is its only offset parent
    if (my.getCss(elem, 'position') === 'fixed') {
      // we assume that getBoundingClientRect is available when computed position is fixed
      offset = elem.getBoundingClientRect();
    } else {
      // Get *real* offsetParent
      offsetParent = my.getOffsetParent(elem);

      // Get correct offsets
      offset = my.getOffset(elem);
      if (!my.isNodeName(offsetParent, 'html')) {
        parentOffset = my.getOffset(offsetParent);
      }

      // Add offsetParent borders
      parentOffset.top += parseFloat(my.getCss(offsetParent, 'borderTopWidth'));
      parentOffset.left += parseFloat(my.getCss(offsetParent, 'borderLeftWidth'));
    }

    // Subtract parent offsets and element margins
    // note: when an element has margin: auto the offsetLeft and marginLeft
    // are the same in Safari causing offset.left to incorrectly be 0
    return {
      top: offset.top - parentOffset.top - parseFloat(my.getCss(elem, 'marginTop')),
      left: offset.left - parentOffset.left - parseFloat(my.getCss(elem, 'marginLeft')),
    };
  };

  /**
   * Returns the offset of the domElement
   * @returns {Number}
   */
  my.getScrollTop = function(elem) {
    const win = my.getWindow(elem);
    const prop = 'pageYOffset';
    const method = 'scrollTop';

    return win ? (prop in win ? win[prop] : win.document.documentElement[method]) : elem[method];
  };

  my.shouldPostTheEntireCalibrationObject = function(goalType) {
    switch (goalType) {
      case 'homePurchase':
        return true;
      case 'healthCare':
        return true;
      case 'largePurchase':
        return true;
      default:
        return false;
    }
  };

  my.getLogoInlineCssStyle = function() {
    let logo = `${ADV.settings.endpoints.imgDir}logo-hires-color-white.png`;
    const whiteLabel = ADV.data.user.WhiteLabelDashboardLogoAbsoluteUrl;
    let extraStyling = '';
    if (whiteLabel) {
      logo = whiteLabel;
      extraStyling = 'background-color: #242424;' + 'margin: 0;' + 'width: 250px;';
    }
    return `background-image: url(${logo});${extraStyling}`;
  };

  my.getAdviserTopNavBarData = function() {
    return {
      logoInlineCssStyle: my.getLogoInlineCssStyle(),
      hasWhiteLabel: !!ADV.data.user.WhiteLabelDashboardLogoAbsoluteUrl,
    };
  };

  my.getClientListData = function(clients) {
    return {
      clients,
      user: ADV.data.user,
      hasWhiteLabel: !!ADV.data.user.WhiteLabelDashboardLogoAbsoluteUrl,
    };
  };

  my.isNumeric = function(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  };

  my.isNonZeroNumeric = function(n) {
    return my.isNumeric(n) && parseInt(n) !== 0;
  };

  my.setHelp = function(helpDescriptor) {
    ADV.Help = Object.assign(
      {
        key: my.randomString(5),
      },
      helpDescriptor || {},
    );
    return ADV.Help.key;
  };

  my.unsetHelp = function(key) {
    if (ADV.Help && ADV.Help.key === key) {
      ADV.Help = null;
    }
  };

  my.escapeHTML = function(string) {
    const entityMap = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
      '/': '&#x2F;',
    };
    return String(string).replace(/[&<>"'\/]/g, s => entityMap[s]);
  };

  my.getProfileEditShellAdvancedSectionVisibility = function() {
    let isVisible = false;
    document.querySelectorAll('.outer-advanced + .advanced').forEach(advancedSection => {
      isVisible = isVisible || $(advancedSection).css('display') !== 'none';
    });
    return isVisible;
  };

  my.setProfileEditShellAdvancedButtonsVisibility = function(visible) {
    document.querySelectorAll('.outer-advanced').forEach(advancedButton => {
      advancedButton.setAttribute('style', visible ? 'display:block;' : 'display:none;');
    });
  };

  my.numberFrom = function(quantity) {
    if (quantity === 0) {
      quantity = '0';
    }
    const trimmed = (quantity || '')
      .toString()
      .replace(/[$]/g, '')
      .replace(/[,]/g, '');
    if (ADV.util.isNumeric(trimmed)) {
      return +trimmed;
    }
    return quantity;
  };

  my.getCurrentPPI = function() {
    let elem;
    let ppi;
    elem = document.createElement('div');
    elem.style.width = '1in';
    document.body.appendChild(elem);
    ppi = elem.offsetWidth;
    document.body.removeChild(elem);
    return ppi;
  };
  my.openTrainerVideoIfFirstPage = function() {
    document.body.dispatchEvent(new CustomEvent('openTrainerVideoIfFirstPage'));
  };

  my.shallowEqual = function(objA, objB) {
    if (objA === objB) {
      return true;
    }

    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
      return false;
    }

    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);

    if (keysA.length !== keysB.length) {
      return false;
    }

    // Test for A's keys different from B.
    const bHasOwnProperty = hasOwnProperty.bind(objB);
    for (let i = 0; i < keysA.length; i++) {
      if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
        return false;
      }
    }

    return true;
  };

  my.monotonicSequenceGenerator = function() {
    if (!window._monotonicSequenceGenerator) {
      window._monotonicSequenceGenerator = 1;
    }
    window._monotonicSequenceGenerator++;
    return window._monotonicSequenceGenerator;
  };

  /**
   * Clears cache on Dashboard controller
   */
  my.clearDashboardCache = function() {
    sessionStorage.removeItem('dashboardData');
  };

  return my;
})(ADV.util || {});

ADV.util = (function(util) {
  util.SessionTimeout = (function() {
    let warningTimeout;
    let sessionTimeout;
    let warningModalTrigger;

    /**
     * Stops the front-end timer (doesn't stop the session from actually ending).
     */
    function stopTimer() {
      clearTimeout(warningTimeout);
      clearTimeout(sessionTimeout);
    }

    /**
     * Called when the session has timed out.
     */
    function sessionDidTimeOut() {
      // redirect to login page
      ADV.Controller.logout(true);
    }

    /**
     * Starts or resets the timer.
     */
    function startTimer(displayModalCallback) {
      stopTimer();

      warningModalTrigger = displayModalCallback;
      warningTimeout = setTimeout(
        warningModalTrigger,
        ADV.settings.misc.session_timeout - ADV.settings.misc.session_warning_time,
      );
      sessionTimeout = setTimeout(sessionDidTimeOut, ADV.settings.misc.session_timeout);
    }

    /**
     * Resets the timer. Only works if one has been set in the first place with _startTimer()
     */
    function extendTimer() {
      if (sessionTimeout) {
        clearTimeout(sessionTimeout);
        sessionTimeout = setTimeout(sessionDidTimeOut, ADV.settings.misc.session_timeout);
      }
      if (warningTimeout) {
        clearTimeout(warningTimeout);
        warningTimeout = setTimeout(
          warningModalTrigger,
          ADV.settings.misc.session_timeout - ADV.settings.misc.session_warning_time,
        );
      }
    }

    return {
      startTimer,
      stopTimer,
      extendTimer,
    };
  })();
  return util;
})(ADV.util || {});

ADV.util = (function(my) {
  var current_spinner_id;

  my.Spinner = function() {
    var $body = $('body');

    var id = ADV.util.randomString();
    current_spinner_id = id;

    if (!$body.find('.spinner').length) {
      $body.addClass('loading');
      $body.prepend(
        '<div class="spinner spinner-overlay"><div class="spinner spinner-container" role="status" aria-live="polite"></div></div>',
      );
      $('.spinner-container').append(
        '<p class="sr-only">Content is loading</p><i alt="loading"></i>',
      );
    }

    return {
      destroy: function() {
        if (current_spinner_id === id) {
          $body.removeClass('loading');
          $body.find('.spinner').remove();
          current_spinner_id = null;
        }
      },
    };
  };

  return my;
})(ADV.util || {});

ADV.util = (function(my) {
  /**
   * Sets value selected in all <select>, optionally within $scope, that has data-value defined.
   * @param $scope
   */
  my.selectSelects = function($scope) {
    $scope = $scope || $(document);
    $scope.find('select[data-value]').each(function() {
      var $this = $(this);
      my.selectDropdownValue($this.get(0), $this.data('value'));
    });
  };

  /**
   * Initializes all <select> within $scope using the legacy OPL Select bridge. Ignores any <select>
   * with data-custom attribute, since those will be instantiated individually.
   * @param $scope
   */
  my.initSelectsWithDefaultOptions = function($scope) {
    my.selectSelects($scope);

    if (!$.fn.selectize) {
      return;
    }

    $scope.find('select').each(function() {
      var $this = $(this);
      if (!$this.data('custom') && !$this.hasClass('selectized')) {
        $this.selectize();
      }
    });
  };

  /**
   * Initializes input boxes with units (div.input). This is done using EVENT DELEGATION on $scope, so it's only necessary
   * to do once on $scope. Inputs don't need to be live in DOM at time function call.
   * @param $scope
   */
  my.initCustomInputBoxes = function($scope) {
    //clicking on box focuses input
    $scope.on('click', 'div.input', function(e) {
      e.preventDefault();
      e.stopPropagation();
      $(this)
        .find('input')
        .focus();
    });

    //event handlers for text input box
    $scope.on('focus', 'div.input input', function() {
      $(this)
        .parent()
        .addClass('focus');
    });
    $scope.on('blur', 'div.input input', function() {
      $(this)
        .parent()
        .removeClass('focus');
    });
  };

  /**
   * Selects an option of a <\select>.
   * @param select //DOM element
   * @param value
   */
  my.selectDropdownValue = function(select, value) {
    //make sure value is parsed as string
    if (value.toString) value = value.toString();
    for (var i = 0; i < select.options.length; i++) {
      if (select.options[i].value === value) {
        select.selectedIndex = i;
        $(select).data('val', value);
        break;
      }
    }
  };

  my.formatInputField = function($field) {
    if ($field.val() !== '') {
      switch ($field.data('type')) {
        case 'money':
          var val = $field.val().replace(/[^0-9.]/g, '') * 1;
          if (val < 0) {
            val = -1 * val;
          }
          $field.val(my.number_format(val));
          break;

        case 'integer':
          $field.val(my.number_format($field.val(), 0));
          break;

        case 'interest':
          if ($field.val() < 0) {
            $field.val(-1 * $field.val());
          }
          $field.val(my.number_format($field.val(), 2));
          break;
        case 'interest-negative':
          $field.val(my.number_format($field.val(), 2));
          break;
      }
    }
  };

  my.bindAutoFormatInputFields = function($scope) {
    //unbind first, just in case
    my.unbindAutoFormatInputFields($scope);

    function formatFields() {
      $scope.find('input').each(function() {
        ADV.util.formatInputField($(this));
      });
    }

    //start off by formatting
    formatFields();

    //format input on change
    $scope.on('change.afif', 'input', function() {
      ADV.util.formatInputField($(this));
    });
  };

  my.unbindAutoFormatInputFields = function($scope) {
    $scope.off('change.afif');
  };

  /**
   * Initializes input boxes with data-type="date".
   * @param $scope
   */
  my.initDatepickerInputs = function($scope) {
    //rome options
    var options = {
      time: false,
      inputFormat: 'MM/DD/YYYY',
    };

    var $inputs = $scope.find('input[data-type="date"]');
    var timeout;

    function initDatePicker($inp) {}

    //iterate through all inputs with data-type="date"
    $inputs.each(function() {
      var $inp = $(this);

      //make sure we don't do this twice
      if ($inp.hasClass('rome-init')) return;

      initDatePicker($inp);
    });
  };

  /**
   * Calls the commonly used input setup functions.
   * @param $scope
   */
  my.setupInputs = function($scope) {
    ADV.util.initSelectsWithDefaultOptions($scope);
    ADV.util.initCustomInputBoxes($scope);
    ADV.util.bindAutoFormatInputFields($scope);
    ADV.util.initDatepickerInputs($scope);
  };

  my.adaptEarmarkMultiSelectFormData = function(values, field) {
    var accountEarmarks = values[field + '[Type]'] || [];
    delete values[field + '[Type]'];
    if (accountEarmarks.length) {
      values[field] = [];
    }

    for (var _i = 0; _i < accountEarmarks.length; _i++) {
      values[field].push({
        Type: accountEarmarks[_i],
      });
    }
    return values;
  };

  my.formatValue = function(value, type) {
    var val = value || value === 0 ? value.toString() : '';
    if (value !== '') {
      switch (type) {
        case 'money':
          val = val.replace(/[^0-9.]/g, '') * 1;
          if (val < 0) {
            val = -1 * val;
          }
          return my.number_format(val);
        case 'integer':
          return my.number_format(val, 0);

        case 'interest':
          if (val < 0) {
            val = -1 * val;
          }
          return my.number_format(val, 2);
        case 'interest-negative':
          return my.number_format(val, 2);
        case 'percentage':
          if (val < 0) {
            val = -1 * val;
          }
          val = my.number_format(val, 2);
          if (+val == Math.trunc(val)) {
            val = Math.trunc(val);
          }
          return `${val}%`;
      }
    } else {
      value = '0';
    }
    return value;
  };

  return my;
})(ADV.util || {});

/* global ADV, routeMatcher */
/*
    eslint-disable
    func-names,
    no-underscore-dangle,
    no-throw-literal,
    camelcase,
    no-restricted-syntax,
    no-prototype-builtins,
    no-param-reassign,
*/

ADV.util.Router = (function() {
  const _my = {
    navigateAwayCallback: null,
    ignoreHashChange: false,
  };

  function _callControllerFromObj(id, params) {
    if (ADV.Controller[id]) {
      ADV.Controller[id].call(undefined, params);
    } else {
      throw `ADV.util.Router: Controller[${id}] does not exist.`;
    }
  }

  /**
   * Returns a hash string from a route ID and parameter map.
   * If id does not exist, throws an Exception.
   * @param id
   * @param params
   * @returns {*|String}
   * @private
   */
  function _getHashFromObj(id, params = {}) {
    const hash = ADV.routes[id];

    if (!hash) {
      throw `Undefined route '${id}'`;
    }

    const rm = routeMatcher(hash.path);

    return {
      path: rm.stringify(params),
      type: hash.type,
      show_plan_selector: hash.has_plan_selection,
    };
  }

  /**
   * Returns an object with the id and params object {id:[String],params:{}} from a hash string.
   * Returns false if no match was found.
   * @param hash
   * @returns {*}
   * @private
   */
  function _getObjFromHash(hash) {
    if (!hash) {
      return false;
    }

    for (const k in ADV.routes) {
      if (ADV.routes.hasOwnProperty(k)) {
        const rm = routeMatcher(ADV.routes[k].path);
        const p = rm.parse(hash);
        const { type, has_plan_selection, skipWrapper = false } = ADV.routes[k];

        if (p !== null) {
          return {
            id: k,
            params: p,
            type,
            has_plan_selection,
            skipWrapper,
          };
        }
      }
    }

    return false;
  }

  /**
   * Calls a React route via the AdviserArea component.
   * @param id
   * @param params
   * @param show_plan_selector
   */
  function _react_route(controller, params, show_plan_selector, skipWrapper = false) {
    const event = new CustomEvent('reactroute', {
      detail: {
        controller,
        params,
        show_plan_selector,
        skipWrapper,
        isReactRoute: true,
      },
    });

    document.dispatchEvent(event);
  }

  /**
   * onHashChange event handler.
   */
  function onHashChange() {
    const hash = ADV.util.getHash();
    const o = _getObjFromHash(hash);

    if (o) {
      if (_my.navigateAwayCallback) {
        if (!_my.navigateAwayCallback()) {
          // halt if callback returns false, and go back to the previous route
          _my.ignoreHashChange = true;

          window.history.go(-1);

          return;
        }
      }

      if (_my.ignoreHashChange) {
        // ignore just once, then reset.
        _my.ignoreHashChange = false;

        return;
      }

      if (o.type === 'React') {
        _react_route(o.id, o.params, o.has_plan_selection, o.skipWrapper);
      }
    }
  }

  /**
   * Returns an object which represents the current hash.
   * @return {*}
   */
  function status() {
    return _getObjFromHash(ADV.util.getHash());
  }

  async function go2(id, params, doNotRoute /* DO NOT USE THIS */) {
    if (_my.navigateAwayCallback instanceof Function && !(await _my.navigateAwayCallback())) {
      return false;
    }

    const { path } = _getHashFromObj(id, params || {});

    if (doNotRoute) {
      _my.ignoreHashChange = true;
    }

    const previousHash = window.location.hash;
    window.location.hash = path;

    if (previousHash === `#${path}`) {
      return onHashChange();
    }

    return true;
  }

  /**
   * Routes based on current hash. Returns true if a match was found, false otherwise.
   * NavigateAwayCallback is ignored.
   * @return boolean
   */
  function route() {
    const o = status(); // get current hash object.
    if (o) {
      _callControllerFromObj(o.id, o.params);
      return true;
    }
    return false;
  }

  function init() {
    window.onhashchange = onHashChange;
  }

  /**
   * Registers a callback to be called when navigating to a different route.
   * If the callback DOESNT return true, the route change is cancelled.
   * This callback must be unregistered with unregisterNavigateAwayCallback() when
   * no longer needed.
   * @param callback
   */
  function registerNavigateAwayCallback(callback) {
    _my.navigateAwayCallback = callback;
  }

  /**
   * Unregisters the callback.
   */
  function unregisterNavigateAwayCallback() {
    _my.navigateAwayCallback = null;
  }

  init();

  return {
    route,
    status,
    go2,
    registerNavigateAwayCallback,
    unregisterNavigateAwayCallback,
    getRegisteredNavigateAwayCallback() {
      return _my.navigateAwayCallback;
    },
    getObjFromHash: _getObjFromHash,
    getHashFromObj: _getHashFromObj,
  };
})();

ADV.util = (function (my) {

	/**
	 * Returns false if one or more of the modules aren't loaded. Returns
	 * true otherwise.
	 * @param modules //array or string
	 */
	my.isLoaded = function(modules){
		modules = $.isArray(modules) ? modules : [modules];
		window.loaded_resources = window.loaded_resources || {};
		for(var i = 0; i < modules.length; i++){
			if(!window.loaded_resources[modules[i]]){
				return false;
			}
		}
		return true;
	};

	/**
	 * Modular loading system, using LazyLoad. Only loads modules once. All modules must be defined
	 * in ADV.resources object (adv.resources.js).
	 * Ex: ADV.util.require(['foo','bar'], callback);
	 *     ADV.util.require('foo', callback);
	 * @param modules //[array|string] the id of the module, or array of strings
	 * @param callback //called after all of the resources have loaded
	 */
	my.require = function(modules, callback, noRecall){

		modules = $.isArray(modules) ? modules : [modules];

		//make sure all of the modules exist
		var i, len = modules.length;
		for(i = 0; i < len; i++){
			if(ADV.util.isEmpty(ADV.resources[modules[i]])){
				throw('"ADV.util.require: ADV.resources.' + modules[i] + '" does not exist.');
			}
		}

		//check to see if already loaded. If they are, call the callback and stop.
		if(ADV.util.isLoaded(modules)){
			if (!noRecall) callback.apply();
			return;
		}

		//show spinner before we begin loading
		var spinner = new ADV.util.Spinner();

		//combine all of the JS assets
		var js_assets = modules.reduce(function(prev, cur) {
			return prev.concat(ADV.resources[cur]);
		}, []);

		//load the modules via LazyLoad
		LazyLoad.js(js_assets, function(){
			for(var k in modules){
				window.loaded_resources[modules[k]] = true;
			}
			spinner.destroy();
			callback.apply();
		});
	};


	return my;
})(ADV.util || {});
ADV.util = (function(my) {
  /**
   * Performs an API request to the Advizr server.
   * Parameters: {
   *   uri [string], //required. ex: Adviser/Adviser/GetClients
   *   data [Object], //any data to send to server along with request
   *   showSpinner [bool], //default: true
   *   dataType [string], //default: "json"
   *   type [string], //default: "GET"
   *   onSuccess [Callable], //event handler for success case (resp.success === true),
   *   onFailure [Callable] //event handler for failure case (resp.success === false),
   *   onRequestError [Callable] //event handler for request error
   * }
   *
   * Also accepts any parameters
   * @param opts
   */
  my.request = async function(opts, isAsync) {
    const hookKey = `${opts.method || 'GET'}.${opts.uri}`;
    if (ADV.mocks && ADV.mocks.map && ADV.mocks.map[hookKey]) {
      return ADV.mocks.requestAPIMock(opts, isAsync, ADV.mocks.map[hookKey](opts));
    }
    /** Promise if we need it * */

    /** default event handlers * */

    const default_event_handlers = {
      onSuccess(respData) {}, // does nothing
      onFailure(errors, errorType, respData, reqData) {
        if (!isAsync) {
          // parse error (may be a string, array, or object)
          const errorString = ADV.util.getErrorsHTMLFromResponse(errors);

          if (options.redirectTo500OnFailure) {
            ADV.util.Router.go2('FatalError');
          } else if (options.parsedErrorCallback) {
            options.parsedErrorCallback.call(undefined, errorString);
          }
        }
      },
      onError(httpReq, status, exception) {
        const licenseInUse = 'License in use';

        if (
          httpReq.status === 401 &&
          ADV.util.env('isAdviserArea') &&
          httpReq.getResponseHeader('X-Adv-Reason') === licenseInUse
        ) {
          return window.ADV.adviser.showMultipleSessionWarningModal();
        }

        if (httpReq.status === 401) {
          return ADV.Controller.logout(false, true);
        }

        if (!isAsync) {
          //do some things based on status code
          switch (httpReq.status) {
            case 402: //redirect to checkout
              var location = ADV.util.Router.status();
              if (location.id !== 'Checkout') {
                ADV.util.Router.go2('Checkout');
              }
              return; // don't call onFailure
            case 403: // incorrect page/unauthorized
              return; // don't call onFailure
            case 503: // Maintenance
              window.location.href = '/Maintenance';
              return; // don't call onFailure
          }

          // call the onFailure event handler
          options.onFailure.call(undefined, ADV.settings.MsgLib.generic_error);
        }
      },
    };

    const headersOptions = () => {
      const baseOptions = {
        xsrf: window.ADV.settings.tokens.xsrf,
      };

      if (window.ADV.settings.tokens.access_token) {
        return {
          ...baseOptions,
          authorization: `Bearer ${window.ADV.settings.tokens.access_token}`,
        };
      }
      return baseOptions;
    };

    /** default options * */

    const headers = {};

    const { xsrf, authorization } = headersOptions();

    const sid = sessionStorage.getItem('sid');

    if (!_.isEmpty(sid)) {
      headers['X-Adv-Sid'] = sid;
    }

    if (!_.isEmpty(xsrf)) {
      headers['X-Xsrf-Token'] = xsrf;
    }

    if (authorization) {
      headers.Authorization = authorization;
    }

    var options = $.extend(
      {
        uri: '',
        urlParams: {},
        showSpinner: true,
        type: 'GET',
        onSuccess: default_event_handlers.onSuccess,
        onFailure: default_event_handlers.onFailure,
        onError: default_event_handlers.onError,
        dataType: 'json', // json or html
        data: {},
        sendStringifyJSON: false, // if true, sends {[sendJSONParam]: JSON.stringify(options.data)}
        sendStringifyJSONParam: 'json',
        xhrFields: { withCredentials: true },
        redirectTo500OnFailure: false,
        parsedErrorCallback: null, // if this is provided, and there are validation errors, this callback is called with HTML
        // instead of shown in a popup (the default)
        doNotExtendSession: false,
        headers,
      },
      opts,
    );

    /** create the request * */

    if (options.uri.indexOf('?') > -1) {
      options.uri += '&';
    } else {
      options.uri += '?';
    }

    options.urlParams.cb = new Date().getTime();

    if (ADV.data.cx) {
      options.urlParams.cx = true;
    }

    if (ADV.data.oid) {
      options.urlParams.oid = encodeURIComponent(ADV.data.oid);
    }

    if (ADV.cobrowsingOperator) {
      options.urlParams.cobrowsingOperator = ADV.cobrowsingOperator;
    }

    Object.keys(options.urlParams).forEach(function(key) {
      options.uri += `${key}=${options.urlParams[key]}&`;
    });

    if (options.uri.slice(-1) === '&') {
      options.uri = options.uri.substr(0, options.uri.length - 1);
    }

    // show loader
    let spinner;
    if (options.showSpinner) {
      spinner = new ADV.util.Spinner();
    }

    // convert data to stringified JSON
    if (options.sendStringifyJSON) {
      const data = {};
      data[options.sendStringifyJSONParam] = JSON.stringify(options.data);
      options.data = data;
    }

    // prepare parameters for $.ajax
    const ajax_params = $.extend(
      {
        url: ADV.settings.endpoints.api + options.uri,
        success(resp) {
          let response_data = {};
          const request_data = options.data;

          // due to the way the backend is coded, we have to manually combine these two response parameters
          if (resp && resp.payload) {
            response_data = $.extend(resp.payload.viewData, resp.payload.extensions);
          }

          if (resp && resp.success) {
            options.onSuccess.call(undefined, response_data);
          } else if (resp) {
            options.onFailure.call(
              undefined,
              resp.errors,
              resp.errorType,
              response_data,
              request_data,
            );
          }
        },
        error: options.onError,
      },
      options,
    );

    /** send the request * */

    return new Promise(function(resolve, reject) {
      const finalize = { success: true, param: null };
      $.ajax(ajax_params)
        .done(function(resolved, __, xhr) {
          if (xhr.getResponseHeader('X-Slided') === '1' && !options.doNotExtendSession) {
            ADV.util.SessionTimeout.extendTimer();
          }

          const sidRenewToken = xhr.getResponseHeader('X-Adv-Sid-Renew');
          const xsrfRenewToken = xhr.getResponseHeader('X-Xsrf-Token-Renew');

          if (!_.isEmpty(sidRenewToken)) {
            sessionStorage.setItem('sid', sidRenewToken);
          }

          if (!_.isEmpty(xsrfRenewToken)) {
            sessionStorage.setItem('xsrf', xsrfRenewToken);
          }

          finalize.success = true;
          finalize.param = resolved;
        })
        .fail(function(xhr, status, error) {
          finalize.success = false;
          finalize.param = (xhr && xhr.status) || status;
          default_event_handlers.onError(xhr, status, error);
        })
        .always(function() {
          if (spinner) {
            spinner.destroy();
          }
          if (finalize.success) {
            resolve(finalize.param);
          } else {
            reject(finalize.param);
          }
        });
    });
  };

  my.redirectToLoginPage = function(noRedirect, timeout) {
    if (ADV.settings.endpoints.logOutRedirectUrl) {
      location.href = ADV.settings.endpoints.logOutRedirectUrl;
    } else {
      const query = { action: 'logout' };

      if (timeout) {
        query.timeout = '1';
      }

      if (!noRedirect && my.getHash()) {
        query.returnurl = `#${my.getHash()}`;
      }

      const queryString = Object.entries(query)
        .map(([k, v]) => `${k}=${v}`)
        .join('&');

      location.href = `${ADV.settings.endpoints.api}?${queryString}`;
    }
  };

  (my.downloadPDF = function(
      clientId,
      fpId,
      beforeDownload,
      whenTimeoutExpires,
      method,
      jsonString,
      pdfBool,
    ) {
      beforeDownload = beforeDownload || function() {};
      whenTimeoutExpires = whenTimeoutExpires || function() {};
      method = method || 'GET';
      jsonString = jsonString || null;
      pdfBool = pdfBool == null ? true : pdfBool;
      beforeDownload();
      const form = document.createElement('form');
      let json;
      let clientIdInput;
      let fpIdInput;
      const pdf = document.createElement('input');
      let queryString = '';
      let csrfInput;

      form.method = method;
      form.style.display = 'none';

      if (method == 'POST') {
        queryString = `?clientId=${clientId}&fpId=${fpId}`;
      } else {
        clientIdInput = document.createElement('input');
        clientIdInput.name = 'clientId';
        clientIdInput.value = clientId;
        form.appendChild(clientIdInput);

        fpIdInput = document.createElement('input');
        fpIdInput.name = 'fpId';
        fpIdInput.value = fpId;
        form.appendChild(fpIdInput);
      }

      pdf.name = 'pdf';
      pdf.value = pdfBool.toString();
      form.appendChild(pdf);

      if (jsonString !== null) {
        json = document.createElement('input');
        json.name = 'json';
        json.value = jsonString;
        form.appendChild(json);
      }
      const iframe = document.createElement('iframe');
      iframe.name = `download_pdf`;
      iframe.style.display = 'none';
      document.body.appendChild(iframe);

      csrfInput = document.createElement('input');
      csrfInput.name = '__RequestVerificationToken';
      csrfInput.value = ADV.settings.tokens.xsrf;
      form.appendChild(csrfInput);

      form.target = `download_pdf`;
      form.action = `/Consumer/Print${queryString}`;
      iframe.appendChild(form);
      form.submit();
      setTimeout(whenTimeoutExpires, 14000);
    });

  return my;
})(ADV.util || {});

ADV.util = (function (util) {
	util.chart = (function(chart){

		/**
		 * Expects an array of Asset Allocation series data, like follows:
		 * [
		 *   "name": "Cash",
		 *   "y": 0.21,
		 *   "color_group": 0 //will use colors from group 0
		 * ],
		 * [
		 *   "name": "Large Cap Equity",
		 *   "y": 0.44,
		 *   "color_group": 1 //will use colors from group 0
		 * ]
		 *
		 * Returns:
		 * {
		 *   Series: [...],
		 *   Labels: [...]
		 * }
		 *
		 * @param allocation_series
		 *
		 */
		chart.parseAllocationSeries = function(allocation_series){

			var color_groups = ADV.settings.color_groups,
				next_color = [],
				i,
				Series = clone(allocation_series),
				Labels = [];

			//set up next color array
			for(i = 0; i < color_groups.length; i++){
				next_color.push(0);
			}

			$.each(allocation_series, function(k,v){

				var color = color_groups[v.color_group][next_color[v.color_group]];
				if(!color){
					color = color_groups[3][next_color[v.color_group] % color_groups[v.color_group].length];
				}

				Series[k].color = v.color || color;

				Labels.push({
					index: k,
					label: v.name,
					value: v.y,
					color: Series[k].color,
					color_group: v.color_group,
					primary: (next_color[v.color_group] == 0),
					inactive: v.y <= 0
				});

				next_color[v.color_group]++;
			});

			return {
				Series: Series,
				Labels: Labels
			};
		};

		return chart;
	})(util.chart || {});
	return util;
})(ADV.util || {});

ADV.util = (function (my) {

    my.pages = (function(){

        function buildPagination(page, pageCount) {
            if (!!pageCount) {
                var pages = [],
                    offsetPage = page - 1,
                    arrayLength = pageCount - 1,
                    pagesToDisplay = 10,
                    halfPages = Math.floor(pagesToDisplay / 2);
                if (pageCount < 10) {
                    return Array.apply(null, Array(pageCount)).map(function (x, i) {
                        // Builds an array based on the total page count
                        var adjustedIndex = i + 1;
                        return {
                            Page: adjustedIndex,
                            Selected: page == adjustedIndex
                        };
                    });
                }

                var i = offsetPage - halfPages > -1 ? offsetPage - halfPages : 0,
                    l;

                if (offsetPage + halfPages - 1 >= arrayLength) {
                    l = arrayLength;
                    i = l - pagesToDisplay + 1; //offset for array indexes
                } else if (offsetPage <= 5) {
                    l = pagesToDisplay - 1; //offset for array indexes
                } else {
                    l = offsetPage + halfPages + (offsetPage <= halfPages ? offsetPage : 0);
                }

                for (;
                    i <= l;
                    i++) {
                    var adjustedIndex = i + 1;
                    pages.push({
                        Page: adjustedIndex,
                        Selected: page == adjustedIndex
                    });
                }

                if (pages[pagesToDisplay - 1].Page < arrayLength - 1) {
                    pages.splice(pagesToDisplay - 1, 2, {Page: '...', Selected: false, NoClick: true}, {
                        Page: pageCount,
                        Selected: false
                    });
                }

                if (pages[0].Page >= 2) {
                    pages.splice(0, 2, {Page: 1, Selected: false}, {Page: '...', Selected: false, NoClick: true});
                }

                return pages;
            } else {
                return {Pages: [1], Selected: false}
            }
        }

        /* RETURN API */

        return {
            buildPages: buildPagination
        };

    })();

    return my;
})(ADV.util || {});
/*************************************************************************
 * Helpful jquery plugins
 *************************************************************************/

(function($){

    "use strict";

    /**
     * Checks to see if an element is overflowing it's bounds.
     * @return {Boolean}
     */
    $.fn.isOverflowing = function(){
        var el = $(this).get(0);
        var curOverflow = el.style.overflow;
        if ( !curOverflow || curOverflow === "visible" ){
            el.style.overflow = 'hidden';
        }
        var isOverflowing = el.clientWidth < el.scrollWidth || el.clientHeight < el.scrollHeight;

        el.style.overflow = curOverflow;

        return isOverflowing;
    };


    /**
     * Returns a string representing the input type. If it's not an input, it returns the tag name of the element.
     * @return {*}
     */
    $.fn.getInputType = function () {
        return this[0].tagName.toString().toLowerCase() === "input" ?
            $(this[0]).prop("type").toLowerCase() :
            this[0].tagName.toLowerCase();
    };


    /**
     * Serialize form fields into JSON
     * @return {*}
     */
    $.fn.serializeJSON = function(){
        var json = {};
        var form = $(this);
        form.find('input, select, textarea').each(function(){
            var val;
            if (!this.name) return;
            if ('radio' === this.type) {
                if (json[this.name]) { return; }
                json[this.name] = this.checked ? this.value : '';
            } else if ('checkbox' === this.type) {
                val = json[this.name];
                if (!this.checked) {
                    if (!val) { json[this.name] = ''; }
                } else {
                    json[this.name] =
                        typeof val === 'string' ? [val, this.value] :
                            $.isArray(val) ? $.merge(val, [this.value]) :
                                this.value;
                }
            } else if ('select-multiple' == this.type) {
	            var selectedOptions = [],
		            i;
	            if(!this.options) return;
	            if(this.selectedOptions){
		            // HTML5
		            for(i = 0; i < this.selectedOptions.length; i++){
			            selectedOptions.push(this.selectedOptions[i].value);
		            }
	            } else {
		            // non-HTML5
		            for(i = 0; i < this.options.length; i++) {
			            if(this.options[i].selected) {
				            selectedOptions.push(this.options[i].value);
			            }
		            }
	            }
	            json[this.name] = selectedOptions;
            } else {
                json[this.name] = this.value;
            }
        });
        return json;
    };

    /**
     * Converts an object into an array.
     * @return {*}
     */
    $.fn.serializeObject = function(){
        var o = {};
        var a = this.serializeArray();
        $.each(a, function() {
            if (o[this.name] !== undefined) {
                if (!o[this.name].push) {
                    o[this.name] = [o[this.name]];
                }
                o[this.name].push(this.value || '');
            } else {
                o[this.name] = this.value || '';
            }
        });
        return o;
    };

})(jQuery);
/* global ADV, _ */

ADV.Controller = ADV.Controller || {};

/**
 * For Adviser area, routes to either the Client Start page, or the Financial Plan, depending
 * on the state of the client.
 * @param clientId
 */
ADV.Controller.Go2AdviserArea = function() {
  window.location = '/Adviser/Adviser';
};

ADV.Controller.Go2AdminArea = function() {
  window.location = '/Admin/NewMain';
};

ADV.Controller.logout = function(no_redirect, timeout) {
  // clear session storage
  sessionStorage.clear();

  const temp = {};
  const permanent = 'permanent-';
  Object.keys(localStorage).forEach(key => {
    if (key.substr(0, permanent.length) === permanent) {
      temp[key] = localStorage.getItem(key);
    }
  });

  localStorage.clear();

  Object.keys(temp).forEach(key => {
    localStorage.setItem(key, temp[key]);
  });

  const logoutMask = document.createElement('div');

  logoutMask.style = `
        position: fixed;
        background: white;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 2147483647;
      `;

  document.body.appendChild(logoutMask);

  // fetch data from backend
  ADV.util.request({
    uri: 'Session/LogOff',
    onSuccess() {
      ADV.util.redirectToLoginPage(!!no_redirect, !!timeout);
    },
  });
};

/**
 * Created by Josh on 4/4/2016.
 *
 * REMOVE THIS AS SOON REACT MIGRATION IS COMPLETE.
 */
(function() {
  if (!Array.prototype.findIndex) {
    Array.prototype.findIndex = function(predicate) {
      if (this === null) {
        throw new TypeError('Array.prototype.findIndex called on null or undefined');
      }
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }
      var list = Object(this);
      var length = list.length >>> 0;
      var thisArg = arguments[1];
      var value;

      for (var i = 0; i < length; i++) {
        value = list[i];
        if (predicate.call(thisArg, value, i, list)) {
          return i;
        }
      }
      return -1;
    };
  }

  Object.equals = function(object, compareTo) {
    if (object === null) {
      throw new TypeError('Object.equals called on null or undefined');
    }
    if (typeof compareTo !== 'object' || typeof object !== 'object') {
      throw new TypeError('Object.equals must be called on an object');
    }
    var aProps = Object.getOwnPropertyNames(object);
    var bProps = Object.getOwnPropertyNames(compareTo);

    if (aProps.length != bProps.length) {
      return false;
    }

    for (var i = 0; i < aProps.length; i++) {
      var propName = aProps[i];

      if (object[propName] !== compareTo[propName]) {
        return false;
      }
    }
    return true;
  };
})();

(function() {
  if (!Array.prototype.find) {
    Array.prototype.find = function(predicate) {
      'use strict';
      if (this == null) {
        throw new TypeError('Array.prototype.find called on null or undefined');
      }
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }
      var list = Object(this);
      var length = list.length >>> 0;
      var thisArg = arguments[1];
      var value;

      for (var i = 0; i < length; i++) {
        value = list[i];
        if (predicate.call(thisArg, value, i, list)) {
          return value;
        }
      }
      return undefined;
    };
  }
})();

(function() {
  if (typeof window.CustomEvent === 'function') return false;

  function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;
})();

(function() {
  if (!Element.prototype.matches) {
    Element.prototype.matches =
      Element.prototype.matchesSelector ||
      Element.prototype.mozMatchesSelector ||
      Element.prototype.msMatchesSelector ||
      Element.prototype.oMatchesSelector ||
      Element.prototype.webkitMatchesSelector ||
      function(s) {
        var matches = (this.document || this.ownerDocument).querySelectorAll(s),
          i = matches.length;
        while (--i >= 0 && matches.item(i) !== this) {}
        return i > -1;
      };
  }
})();

(function() {
  if (typeof NodeList.prototype.forEach === 'function') return false;
  NodeList.prototype.forEach = Array.prototype.forEach;
})();

(function() {
  if (!Element.prototype.remove) {
    Element.prototype.remove = function() {
      if (this.parentElement) {
        this.parentElement.removeChild(this);
      }
    };
  }

  if (!NodeList.prototype.remove) {
    NodeList.prototype.remove = HTMLCollection.prototype.remove = function() {
      for (var i = this.length - 1; i >= 0; i--) {
        if (this[i] && this[i].parentElement) {
          this[i].parentElement.removeChild(this[i]);
        }
      }
    };
  }
})();

(function() {
  if (typeof window.CustomEvent === 'function') return false; //If not IE

  function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;
})();

(function() {
  if (!Element.prototype.closest) {
    if (!Element.prototype.matches) {
      Element.prototype.matches =
        Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    }
    Element.prototype.closest = function(s) {
      var el = this;
      var ancestor = this;
      if (!document.documentElement.contains(el)) return null;
      do {
        if (ancestor.matches(s)) return ancestor;
        ancestor = ancestor.parentElement;
      } while (ancestor !== null);
      return null;
    };
  }
})();

(function(arr) {
  arr.forEach(function(item) {
    if (item.hasOwnProperty('prepend')) {
      return;
    }
    Object.defineProperty(item, 'prepend', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function prepend() {
        var argArr = Array.prototype.slice.call(arguments),
          docFrag = document.createDocumentFragment();

        argArr.forEach(function(argItem) {
          var isNode = argItem instanceof Node;
          docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
        });

        this.insertBefore(docFrag, this.firstChild);
      },
    });
  });
})([Element.prototype, Document.prototype, DocumentFragment.prototype]);

if (!Element.prototype.scrollIntoViewIfNeeded) {
  Element.prototype.scrollIntoViewIfNeeded = function(centerIfNeeded) {
    centerIfNeeded = arguments.length === 0 ? true : !!centerIfNeeded;

    var parent = this.parentNode,
      parentComputedStyle = window.getComputedStyle(parent, null),
      parentBorderTopWidth = parseInt(parentComputedStyle.getPropertyValue('border-top-width')),
      parentBorderLeftWidth = parseInt(parentComputedStyle.getPropertyValue('border-left-width')),
      overTop = this.offsetTop - parent.offsetTop < parent.scrollTop,
      overBottom =
        this.offsetTop - parent.offsetTop + this.clientHeight - parentBorderTopWidth >
        parent.scrollTop + parent.clientHeight,
      overLeft = this.offsetLeft - parent.offsetLeft < parent.scrollLeft,
      overRight =
        this.offsetLeft - parent.offsetLeft + this.clientWidth - parentBorderLeftWidth >
        parent.scrollLeft + parent.clientWidth,
      alignWithTop = overTop && !overBottom;

    if ((overTop || overBottom) && centerIfNeeded) {
      parent.scrollTop =
        this.offsetTop -
        parent.offsetTop -
        parent.clientHeight / 2 -
        parentBorderTopWidth +
        this.clientHeight / 2;
    }

    if ((overLeft || overRight) && centerIfNeeded) {
      parent.scrollLeft =
        this.offsetLeft -
        parent.offsetLeft -
        parent.clientWidth / 2 -
        parentBorderLeftWidth +
        this.clientWidth / 2;
    }

    if ((overTop || overBottom || overLeft || overRight) && !centerIfNeeded) {
      this.scrollIntoView(alignWithTop);
    }
  };
}
